/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export var GlobalCustomersAcceptedTermDto = {
    serializedName: "GlobalCustomersAcceptedTermDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAcceptedTermDto",
        modelProperties: {
            termId: {
                serializedName: "TermId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalAccountsChangePasswordDto = {
    serializedName: "GlobalAccountsChangePasswordDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsChangePasswordDto",
        modelProperties: {
            oldPassword: {
                serializedName: "OldPassword",
                type: {
                    name: "String"
                }
            },
            newPassword: {
                serializedName: "NewPassword",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedValidationError = {
    serializedName: "GlobalSharedValidationError",
    type: {
        name: "Composite",
        className: "GlobalSharedValidationError",
        modelProperties: {
            propertyName: {
                serializedName: "PropertyName",
                type: {
                    name: "String"
                }
            },
            attemptedValue: {
                serializedName: "AttemptedValue",
                type: {
                    name: "Object"
                }
            },
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            message: {
                serializedName: "Message",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedValidationErrorsResponse = {
    serializedName: "GlobalSharedValidationErrorsResponse",
    type: {
        name: "Composite",
        className: "GlobalSharedValidationErrorsResponse",
        modelProperties: {
            message: {
                serializedName: "Message",
                type: {
                    name: "String"
                }
            },
            errors: {
                required: true,
                serializedName: "Errors",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSharedValidationError"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalAccountsAccountInfoDto = {
    serializedName: "GlobalAccountsAccountInfoDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsAccountInfoDto",
        modelProperties: {
            consultantNumber: {
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            loginStatus: {
                required: true,
                serializedName: "LoginStatus",
                type: {
                    name: "String"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalAccountsResetPasswordDto = {
    serializedName: "GlobalAccountsResetPasswordDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsResetPasswordDto",
        modelProperties: {
            temporaryPassword: {
                serializedName: "TemporaryPassword",
                type: {
                    name: "String"
                }
            },
            newPassword: {
                serializedName: "NewPassword",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedMetadataValidationStringValidationDto = {
    serializedName: "GlobalSharedMetadataValidationStringValidationDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataValidationStringValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            regularExpression: {
                serializedName: "RegularExpression",
                type: {
                    name: "String"
                }
            },
            minLength: {
                serializedName: "MinLength",
                type: {
                    name: "Number"
                }
            },
            maxLength: {
                serializedName: "MaxLength",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSharedMetadataStringPropertyDto = {
    serializedName: "GlobalSharedMetadataStringPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataStringPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationStringValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalAccountsMetadataChangePasswordMetadataDto = {
    serializedName: "GlobalAccountsMetadataChangePasswordMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsMetadataChangePasswordMetadataDto",
        modelProperties: {
            oldPassword: {
                serializedName: "OldPassword",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            newPassword: {
                serializedName: "NewPassword",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            }
        }
    }
};
export var GlobalAccountsPermissionDto = {
    serializedName: "GlobalAccountsPermissionDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsPermissionDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalAccountsPermissionsDto = {
    serializedName: "GlobalAccountsPermissionsDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsPermissionsDto",
        modelProperties: {
            permissions: {
                required: true,
                serializedName: "Permissions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalAccountsPermissionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAddressDto = {
    serializedName: "GlobalCustomersAddressDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAddressDto",
        modelProperties: {
            isPrimary: {
                required: true,
                serializedName: "IsPrimary",
                type: {
                    name: "Boolean"
                }
            },
            addressId: {
                serializedName: "AddressId",
                type: {
                    name: "Number"
                }
            },
            addressType: {
                required: true,
                serializedName: "AddressType",
                type: {
                    name: "String"
                }
            },
            country: {
                serializedName: "Country",
                type: {
                    name: "String"
                }
            },
            region: {
                serializedName: "Region",
                type: {
                    name: "String"
                }
            },
            province: {
                serializedName: "Province",
                type: {
                    name: "String"
                }
            },
            district: {
                serializedName: "District",
                type: {
                    name: "String"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "String"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "String"
                }
            },
            locality: {
                serializedName: "Locality",
                type: {
                    name: "String"
                }
            },
            streetAddress: {
                serializedName: "StreetAddress",
                type: {
                    name: "String"
                }
            },
            zipcode: {
                serializedName: "Zipcode",
                type: {
                    name: "String"
                }
            },
            delivery: {
                serializedName: "Delivery",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersAddressesDto = {
    serializedName: "GlobalCustomersAddressesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAddressesDto",
        modelProperties: {
            customerAddressesCollection: {
                required: true,
                serializedName: "CustomerAddressesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAddressDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedMetadataOperationsReasonDto = {
    serializedName: "GlobalSharedMetadataOperationsReasonDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataOperationsReasonDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            message: {
                serializedName: "Message",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedMetadataOperationsOperationDto = {
    serializedName: "GlobalSharedMetadataOperationsOperationDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataOperationsOperationDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            reasons: {
                required: true,
                serializedName: "Reasons",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSharedMetadataOperationsReasonDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedMetadataOperationsOperationsDto = {
    serializedName: "GlobalSharedMetadataOperationsOperationsDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataOperationsOperationsDto",
        modelProperties: {
            create: {
                serializedName: "Create",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationDto"
                }
            },
            read: {
                serializedName: "Read",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationDto"
                }
            },
            update: {
                serializedName: "Update",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationDto"
                }
            },
            deleteProperty: {
                serializedName: "Delete",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationDto"
                }
            }
        }
    }
};
export var GlobalSharedMetadataValidationEnumValidationDto = {
    serializedName: "GlobalSharedMetadataValidationEnumValidationDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataValidationEnumValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataAddressTypePropertyDto = {
    serializedName: "GlobalCustomersMetadataAddressTypePropertyDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataAddressTypePropertyDto",
        modelProperties: {
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationEnumValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersMetadataValidationAddressPropertyValidationDto = {
    serializedName: "GlobalCustomersMetadataValidationAddressPropertyValidationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataValidationAddressPropertyValidationDto",
        modelProperties: {
            isAddressMatchRequired: {
                required: true,
                serializedName: "IsAddressMatchRequired",
                type: {
                    name: "Boolean"
                }
            },
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            regularExpression: {
                serializedName: "RegularExpression",
                type: {
                    name: "String"
                }
            },
            minLength: {
                serializedName: "MinLength",
                type: {
                    name: "Number"
                }
            },
            maxLength: {
                serializedName: "MaxLength",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataCountryPropertyDto = {
    serializedName: "GlobalCustomersMetadataCountryPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataCountryPropertyDto",
        modelProperties: {
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataValidationAddressPropertyValidationDto"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataAddressPropertyDto = {
    serializedName: "GlobalCustomersMetadataAddressPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataAddressPropertyDto",
        modelProperties: {
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataValidationAddressPropertyValidationDto"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataDeliveryPropertyDto = {
    serializedName: "GlobalCustomersMetadataDeliveryPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataDeliveryPropertyDto",
        modelProperties: {
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationStringValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersMetadataAddressSearchMetadataDto = {
    serializedName: "GlobalCustomersMetadataAddressSearchMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataAddressSearchMetadataDto",
        modelProperties: {
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            allowedSearchResults: {
                required: true,
                serializedName: "AllowedSearchResults",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            displayOrder: {
                required: true,
                serializedName: "DisplayOrder",
                type: {
                    name: "Number"
                }
            },
            maxResults: {
                required: true,
                serializedName: "MaxResults",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataAddressMetadataDto = {
    serializedName: "GlobalCustomersMetadataAddressMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataAddressMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationsDto"
                }
            },
            addressType: {
                serializedName: "AddressType",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressTypePropertyDto"
                }
            },
            country: {
                serializedName: "Country",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataCountryPropertyDto"
                }
            },
            region: {
                serializedName: "Region",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            province: {
                serializedName: "Province",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            district: {
                serializedName: "District",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            locality: {
                serializedName: "Locality",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            streetAddress: {
                serializedName: "StreetAddress",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            zipcode: {
                serializedName: "Zipcode",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressPropertyDto"
                }
            },
            delivery: {
                serializedName: "Delivery",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataDeliveryPropertyDto"
                }
            },
            searchOptions: {
                serializedName: "SearchOptions",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressSearchMetadataDto"
                }
            }
        }
    }
};
export var GlobalCustomersAddressFormatLineDto = {
    serializedName: "GlobalCustomersAddressFormatLineDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAddressFormatLineDto",
        modelProperties: {
            fields: {
                required: true,
                serializedName: "Fields",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            separators: {
                required: true,
                serializedName: "Separators",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAddressFormatDto = {
    serializedName: "GlobalCustomersAddressFormatDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAddressFormatDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            lines: {
                required: true,
                serializedName: "Lines",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAddressFormatLineDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAddressFormatCollectionDto = {
    serializedName: "GlobalCustomersAddressFormatCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAddressFormatCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAddressFormatDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedApprovalDto = {
    serializedName: "GlobalSharedApprovalDto",
    type: {
        name: "Composite",
        className: "GlobalSharedApprovalDto",
        modelProperties: {
            personalData: {
                required: true,
                serializedName: "PersonalData",
                type: {
                    name: "Boolean"
                }
            },
            contact: {
                required: true,
                serializedName: "Contact",
                type: {
                    name: "Boolean"
                }
            },
            marketingOriflame: {
                required: true,
                serializedName: "MarketingOriflame",
                type: {
                    name: "Boolean"
                }
            },
            marketingExternal: {
                required: true,
                serializedName: "MarketingExternal",
                type: {
                    name: "Boolean"
                }
            },
            publication: {
                required: true,
                serializedName: "Publication",
                type: {
                    name: "Boolean"
                }
            },
            newsletters: {
                required: true,
                serializedName: "Newsletters",
                type: {
                    name: "Boolean"
                }
            },
            uplineLeaderData: {
                required: true,
                serializedName: "UplineLeaderData",
                type: {
                    name: "Boolean"
                }
            },
            uplineLeaderBrowse: {
                required: true,
                serializedName: "UplineLeaderBrowse",
                type: {
                    name: "Boolean"
                }
            },
            orderHistory: {
                required: true,
                serializedName: "OrderHistory",
                type: {
                    name: "Boolean"
                }
            },
            marketingConsultant: {
                required: true,
                serializedName: "MarketingConsultant",
                type: {
                    name: "Boolean"
                }
            },
            blockGuaranteeOrdering: {
                required: true,
                serializedName: "BlockGuaranteeOrdering",
                type: {
                    name: "Boolean"
                }
            },
            optedOutOfSponsorSelect: {
                required: true,
                serializedName: "OptedOutOfSponsorSelect",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalSharedMetadataBooleanPropertyDto = {
    serializedName: "GlobalSharedMetadataBooleanPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataBooleanPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataCustomerApprovalMetadataDto = {
    serializedName: "GlobalCustomersMetadataCustomerApprovalMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataCustomerApprovalMetadataDto",
        modelProperties: {
            personalData: {
                serializedName: "PersonalData",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            contact: {
                serializedName: "Contact",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            marketingOriflame: {
                serializedName: "MarketingOriflame",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            marketingExternal: {
                serializedName: "MarketingExternal",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            publication: {
                serializedName: "Publication",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            newsletters: {
                serializedName: "Newsletters",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            uplineLeaderData: {
                serializedName: "UplineLeaderData",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            uplineLeaderBrowse: {
                serializedName: "UplineLeaderBrowse",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            orderHistory: {
                serializedName: "OrderHistory",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            marketingConsultant: {
                serializedName: "MarketingConsultant",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            blockGuaranteeOrdering: {
                serializedName: "BlockGuaranteeOrdering",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            optedOutOfSponsorSelect: {
                serializedName: "OptedOutOfSponsorSelect",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionConfigurationDto = {
    serializedName: "GlobalCustomersSubscriptionConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionConfigurationDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionProductAvailabilityDto = {
    serializedName: "GlobalCustomersSubscriptionProductAvailabilityDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionProductAvailabilityDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionProductsAvailabilityDto = {
    serializedName: "GlobalCustomersSubscriptionProductsAvailabilityDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionProductsAvailabilityDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersSubscriptionProductAvailabilityDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAutoshipPackageDto = {
    serializedName: "GlobalCustomersAutoshipPackageDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAutoshipPackageDto",
        modelProperties: {
            packageId: {
                required: true,
                serializedName: "PackageId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageSrc: {
                serializedName: "ImageSrc",
                type: {
                    name: "String"
                }
            },
            totalPriceForTheFirstStep: {
                required: true,
                serializedName: "TotalPriceForTheFirstStep",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersAutoshipTypeDto = {
    serializedName: "GlobalCustomersAutoshipTypeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAutoshipTypeDto",
        modelProperties: {
            typeId: {
                required: true,
                serializedName: "TypeId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            category: {
                required: true,
                serializedName: "Category",
                type: {
                    name: "String"
                }
            },
            packages: {
                required: true,
                serializedName: "Packages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAutoshipPackageDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAutoshipTypesDto = {
    serializedName: "GlobalCustomersAutoshipTypesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAutoshipTypesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAutoshipTypeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersArticleDto = {
    serializedName: "GlobalCustomersArticleDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersArticleDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersAutoshipLegalArticlesDto = {
    serializedName: "GlobalCustomersAutoshipLegalArticlesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAutoshipLegalArticlesDto",
        modelProperties: {
            privacyPolicy: {
                serializedName: "PrivacyPolicy",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersArticleDto"
                }
            },
            termsAndConditions: {
                serializedName: "TermsAndConditions",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersArticleDto"
                }
            }
        }
    }
};
export var GlobalCustomersAutoshipConsumerDto = {
    serializedName: "GlobalCustomersAutoshipConsumerDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAutoshipConsumerDto",
        modelProperties: {
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersAutoshipInstructionDto = {
    serializedName: "GlobalCustomersAutoshipInstructionDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAutoshipInstructionDto",
        modelProperties: {
            newConsumer: {
                serializedName: "NewConsumer",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersAutoshipConsumerDto"
                }
            },
            existingConsumerId: {
                serializedName: "ExistingConsumerId",
                type: {
                    name: "Number"
                }
            },
            packageId: {
                serializedName: "PackageId",
                type: {
                    name: "Number"
                }
            },
            frequency: {
                serializedName: "Frequency",
                type: {
                    name: "Number"
                }
            },
            status: {
                required: true,
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            newAutoshipId: {
                serializedName: "NewAutoshipId",
                type: {
                    name: "Number"
                }
            },
            newOrderId: {
                serializedName: "NewOrderId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalConceptsConceptAvailabilityDto = {
    serializedName: "GlobalConceptsConceptAvailabilityDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptAvailabilityDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            isNoLongerForSale: {
                required: true,
                serializedName: "IsNoLongerForSale",
                type: {
                    name: "Boolean"
                }
            },
            isSoldOut: {
                required: true,
                serializedName: "IsSoldOut",
                type: {
                    name: "Boolean"
                }
            },
            isOutOfStock: {
                required: true,
                serializedName: "IsOutOfStock",
                type: {
                    name: "Boolean"
                }
            },
            isNotSoldOnline: {
                required: true,
                serializedName: "IsNotSoldOnline",
                type: {
                    name: "Boolean"
                }
            },
            isComingSoon: {
                required: true,
                serializedName: "IsComingSoon",
                type: {
                    name: "Boolean"
                }
            },
            isLowStock: {
                required: true,
                serializedName: "IsLowStock",
                type: {
                    name: "Boolean"
                }
            },
            isOffer: {
                required: true,
                serializedName: "IsOffer",
                type: {
                    name: "Boolean"
                }
            },
            isNew: {
                required: true,
                serializedName: "IsNew",
                type: {
                    name: "Boolean"
                }
            },
            isLastChance: {
                required: true,
                serializedName: "IsLastChance",
                type: {
                    name: "Boolean"
                }
            },
            isUntilStockLasts: {
                required: true,
                serializedName: "IsUntilStockLasts",
                type: {
                    name: "Boolean"
                }
            },
            isBundle: {
                required: true,
                serializedName: "IsBundle",
                type: {
                    name: "Boolean"
                }
            },
            isBackorder: {
                required: true,
                serializedName: "IsBackorder",
                type: {
                    name: "Boolean"
                }
            },
            isDeleted: {
                required: true,
                serializedName: "IsDeleted",
                type: {
                    name: "Boolean"
                }
            },
            isSalesLimited: {
                required: true,
                serializedName: "IsSalesLimited",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalConceptsAvailabilitiesQueryDto = {
    serializedName: "GlobalConceptsAvailabilitiesQueryDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsAvailabilitiesQueryDto",
        modelProperties: {
            conceptCodes: {
                serializedName: "ConceptCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalConceptsConceptsAvailabilityDto = {
    serializedName: "GlobalConceptsConceptsAvailabilityDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptsAvailabilityDto",
        modelProperties: {
            conceptsAvailabilityCollection: {
                required: true,
                serializedName: "ConceptsAvailabilityCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalConceptsConceptAvailabilityDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsReplacementDto = {
    serializedName: "GlobalProductsReplacementDto",
    type: {
        name: "Composite",
        className: "GlobalProductsReplacementDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsAvailabilityDto = {
    serializedName: "GlobalProductsAvailabilityDto",
    type: {
        name: "Composite",
        className: "GlobalProductsAvailabilityDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            isNoLongerForSale: {
                required: true,
                serializedName: "IsNoLongerForSale",
                type: {
                    name: "Boolean"
                }
            },
            isSoldOut: {
                required: true,
                serializedName: "IsSoldOut",
                type: {
                    name: "Boolean"
                }
            },
            isOutOfStock: {
                required: true,
                serializedName: "IsOutOfStock",
                type: {
                    name: "Boolean"
                }
            },
            isNotSoldOnline: {
                required: true,
                serializedName: "IsNotSoldOnline",
                type: {
                    name: "Boolean"
                }
            },
            isComingSoon: {
                required: true,
                serializedName: "IsComingSoon",
                type: {
                    name: "Boolean"
                }
            },
            isLowStock: {
                required: true,
                serializedName: "IsLowStock",
                type: {
                    name: "Boolean"
                }
            },
            isOffer: {
                required: true,
                serializedName: "IsOffer",
                type: {
                    name: "Boolean"
                }
            },
            isNew: {
                required: true,
                serializedName: "IsNew",
                type: {
                    name: "Boolean"
                }
            },
            isLastChance: {
                required: true,
                serializedName: "IsLastChance",
                type: {
                    name: "Boolean"
                }
            },
            isUntilStockLasts: {
                required: true,
                serializedName: "IsUntilStockLasts",
                type: {
                    name: "Boolean"
                }
            },
            isBundle: {
                required: true,
                serializedName: "IsBundle",
                type: {
                    name: "Boolean"
                }
            },
            isBackorder: {
                required: true,
                serializedName: "IsBackorder",
                type: {
                    name: "Boolean"
                }
            },
            isSalesLimited: {
                required: true,
                serializedName: "IsSalesLimited",
                type: {
                    name: "Boolean"
                }
            },
            expectedInbound: {
                serializedName: "ExpectedInbound",
                type: {
                    name: "DateTime"
                }
            },
            replacements: {
                required: true,
                serializedName: "Replacements",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsReplacementDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsProductAvailabilityQueryDto = {
    serializedName: "GlobalProductsProductAvailabilityQueryDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductAvailabilityQueryDto",
        modelProperties: {
            productCodes: {
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsProductsAvailabilityDto = {
    serializedName: "GlobalProductsProductsAvailabilityDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductsAvailabilityDto",
        modelProperties: {
            productsAvailabilityCollection: {
                required: true,
                serializedName: "ProductsAvailabilityCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsAvailabilityDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalBackInStockNotificationsBackInStockNotificationDto = {
    serializedName: "GlobalBackInStockNotificationsBackInStockNotificationDto",
    type: {
        name: "Composite",
        className: "GlobalBackInStockNotificationsBackInStockNotificationDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            showBackInStockNotification: {
                required: true,
                serializedName: "ShowBackInStockNotification",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalBackInStockNotificationsBackInStockNotificationCollectionDto = {
    serializedName: "GlobalBackInStockNotificationsBackInStockNotificationCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalBackInStockNotificationsBackInStockNotificationCollectionDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalBackInStockNotificationsBackInStockNotificationDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto = {
    serializedName: "GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto",
    type: {
        name: "Composite",
        className: "GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto",
        modelProperties: {
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            telephoneNumber: {
                serializedName: "TelephoneNumber",
                type: {
                    name: "String"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            notificationChannel: {
                required: true,
                serializedName: "NotificationChannel",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalBackInStockNotificationsBackInStockNotificationsConfigurationDto = {
    serializedName: "GlobalBackInStockNotificationsBackInStockNotificationsConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalBackInStockNotificationsBackInStockNotificationsConfigurationDto",
        modelProperties: {
            marketingApprovalEnabled: {
                required: true,
                serializedName: "MarketingApprovalEnabled",
                type: {
                    name: "Boolean"
                }
            },
            onlyForLoggedUsers: {
                required: true,
                serializedName: "OnlyForLoggedUsers",
                type: {
                    name: "Boolean"
                }
            },
            smsSubscriptionEnabled: {
                required: true,
                serializedName: "SmsSubscriptionEnabled",
                type: {
                    name: "Boolean"
                }
            },
            subscriptionEnabled: {
                required: true,
                serializedName: "SubscriptionEnabled",
                type: {
                    name: "Boolean"
                }
            },
            maxRequestDaysLimit: {
                required: true,
                serializedName: "MaxRequestDaysLimit",
                type: {
                    name: "Number"
                }
            },
            minimumStockLimit: {
                required: true,
                serializedName: "MinimumStockLimit",
                type: {
                    name: "Number"
                }
            },
            replacementsForAnonymousUsers: {
                required: true,
                serializedName: "ReplacementsForAnonymousUsers",
                type: {
                    name: "Boolean"
                }
            },
            showProductLikeItIsOnStock: {
                required: true,
                serializedName: "ShowProductLikeItIsOnStock",
                type: {
                    name: "Boolean"
                }
            },
            isSmsChannelDefault: {
                required: true,
                serializedName: "IsSmsChannelDefault",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersBankAccountDto = {
    serializedName: "GlobalCustomersBankAccountDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersBankAccountDto",
        modelProperties: {
            bankAccountId: {
                serializedName: "BankAccountId",
                type: {
                    name: "Number"
                }
            },
            bankBranchId: {
                serializedName: "BankBranchId",
                type: {
                    name: "Number"
                }
            },
            bankSubBranch: {
                serializedName: "BankSubBranch",
                type: {
                    name: "String"
                }
            },
            bankId: {
                serializedName: "BankId",
                type: {
                    name: "Number"
                }
            },
            number: {
                serializedName: "Number",
                type: {
                    name: "String"
                }
            },
            owner: {
                serializedName: "Owner",
                type: {
                    name: "String"
                }
            },
            documentId: {
                serializedName: "DocumentId",
                type: {
                    name: "Number"
                }
            },
            documentIds: {
                required: true,
                serializedName: "DocumentIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            },
            isApproved: {
                required: true,
                serializedName: "IsApproved",
                type: {
                    name: "Boolean"
                }
            },
            bankAccountType: {
                required: true,
                serializedName: "BankAccountType",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersBankAccountsDto = {
    serializedName: "GlobalCustomersBankAccountsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersBankAccountsDto",
        modelProperties: {
            bankAccountsCollection: {
                required: true,
                serializedName: "BankAccountsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersBankAccountDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersMetadataValidationBankValidationDto = {
    serializedName: "GlobalCustomersMetadataValidationBankValidationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataValidationBankValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataBankBranchPropertyDto = {
    serializedName: "GlobalCustomersMetadataBankBranchPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataBankBranchPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataValidationBankValidationDto"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataValidationBankBranchValidationDto = {
    serializedName: "GlobalCustomersMetadataValidationBankBranchValidationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataValidationBankBranchValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataBankPropertyDto = {
    serializedName: "GlobalCustomersMetadataBankPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataBankPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataValidationBankBranchValidationDto"
                }
            }
        }
    }
};
export var GlobalSharedMetadataValidationDocumentValidationDto = {
    serializedName: "GlobalSharedMetadataValidationDocumentValidationDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataValidationDocumentValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            maxDataSize: {
                required: true,
                serializedName: "MaxDataSize",
                type: {
                    name: "Number"
                }
            },
            supportedMimeTypes: {
                serializedName: "SupportedMimeTypes",
                type: {
                    name: "String"
                }
            },
            allowMultipleDocuments: {
                required: true,
                serializedName: "AllowMultipleDocuments",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalSharedMetadataDocumentPropertyDto = {
    serializedName: "GlobalSharedMetadataDocumentPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataDocumentPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationDocumentValidationDto"
                }
            },
            documentTypeId: {
                required: true,
                serializedName: "DocumentTypeId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSharedMetadataEnumPropertyDto = {
    serializedName: "GlobalSharedMetadataEnumPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataEnumPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationEnumValidationDto"
                }
            },
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersMetadataBankAccountMetadataDto = {
    serializedName: "GlobalCustomersMetadataBankAccountMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataBankAccountMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationsDto"
                }
            },
            bankBranchId: {
                serializedName: "BankBranchId",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataBankBranchPropertyDto"
                }
            },
            bankSubBranch: {
                serializedName: "BankSubBranch",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            bankId: {
                serializedName: "BankId",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataBankPropertyDto"
                }
            },
            number: {
                serializedName: "Number",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            owner: {
                serializedName: "Owner",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            documentId: {
                serializedName: "DocumentId",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataDocumentPropertyDto"
                }
            },
            bankAccountType: {
                serializedName: "BankAccountType",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataEnumPropertyDto"
                }
            }
        }
    }
};
export var GlobalFinanceBankBranchDto = {
    serializedName: "GlobalFinanceBankBranchDto",
    type: {
        name: "Composite",
        className: "GlobalFinanceBankBranchDto",
        modelProperties: {
            bankBranchId: {
                required: true,
                serializedName: "BankBranchId",
                type: {
                    name: "Number"
                }
            },
            bankId: {
                required: true,
                serializedName: "BankId",
                type: {
                    name: "Number"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "String"
                }
            },
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalFinanceBankBranchesDto = {
    serializedName: "GlobalFinanceBankBranchesDto",
    type: {
        name: "Composite",
        className: "GlobalFinanceBankBranchesDto",
        modelProperties: {
            bankBranchesCollection: {
                required: true,
                serializedName: "BankBranchesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalFinanceBankBranchDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalFinanceBankDto = {
    serializedName: "GlobalFinanceBankDto",
    type: {
        name: "Composite",
        className: "GlobalFinanceBankDto",
        modelProperties: {
            bankId: {
                required: true,
                serializedName: "BankId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            swiftBic: {
                serializedName: "SwiftBic",
                type: {
                    name: "String"
                }
            },
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalFinanceBanksDto = {
    serializedName: "GlobalFinanceBanksDto",
    type: {
        name: "Composite",
        className: "GlobalFinanceBanksDto",
        modelProperties: {
            banksCollection: {
                required: true,
                serializedName: "BanksCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalFinanceBankDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingOfferPurchaseDto = {
    serializedName: "GlobalShoppingOfferPurchaseDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferPurchaseDto",
        modelProperties: {
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingOfferPurchasesDto = {
    serializedName: "GlobalShoppingOfferPurchasesDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferPurchasesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOfferPurchaseDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingProductOfferDto = {
    serializedName: "GlobalShoppingProductOfferDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingProductOfferDto",
        modelProperties: {
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingProductOffersDto = {
    serializedName: "GlobalShoppingProductOffersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingProductOffersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingProductOfferDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingOfferBenefitDto = {
    serializedName: "GlobalShoppingOfferBenefitDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferBenefitDto",
        modelProperties: {
            purchasePrice: {
                required: true,
                serializedName: "PurchasePrice",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            isPurchased: {
                required: true,
                serializedName: "IsPurchased",
                type: {
                    name: "Boolean"
                }
            },
            replacedItemCode: {
                serializedName: "ReplacedItemCode",
                type: {
                    name: "String"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingOfferBenefitsDto = {
    serializedName: "GlobalShoppingOfferBenefitsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferBenefitsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOfferBenefitDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingConceptOfferDto = {
    serializedName: "GlobalShoppingConceptOfferDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingConceptOfferDto",
        modelProperties: {
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            shades: {
                serializedName: "Shades",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingProductOffersDto"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingConceptOffersDto = {
    serializedName: "GlobalShoppingConceptOffersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingConceptOffersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingConceptOfferDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingConceptBenefitDto = {
    serializedName: "GlobalShoppingConceptBenefitDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingConceptBenefitDto",
        modelProperties: {
            purchasePrice: {
                required: true,
                serializedName: "PurchasePrice",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            shades: {
                serializedName: "Shades",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOfferBenefitsDto"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingConceptBenefitsDto = {
    serializedName: "GlobalShoppingConceptBenefitsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingConceptBenefitsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingConceptBenefitDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingBasketOfferDto = {
    serializedName: "GlobalShoppingBasketOfferDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingBasketOfferDto",
        modelProperties: {
            offerId: {
                required: true,
                serializedName: "OfferId",
                type: {
                    name: "Number"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            discountPercent: {
                serializedName: "DiscountPercent",
                type: {
                    name: "Number"
                }
            },
            missingQuantity: {
                required: true,
                serializedName: "MissingQuantity",
                type: {
                    name: "Number"
                }
            },
            totalPrice: {
                required: true,
                serializedName: "TotalPrice",
                type: {
                    name: "Number"
                }
            },
            purchases: {
                serializedName: "Purchases",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOfferPurchasesDto"
                }
            },
            products: {
                serializedName: "Products",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingProductOffersDto"
                }
            },
            benefits: {
                serializedName: "Benefits",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOfferBenefitsDto"
                }
            },
            concepts: {
                serializedName: "Concepts",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingConceptOffersDto"
                }
            },
            conceptBenefits: {
                serializedName: "ConceptBenefits",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingConceptBenefitsDto"
                }
            }
        }
    }
};
export var GlobalShoppingBasketOffersDto = {
    serializedName: "GlobalShoppingBasketOffersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingBasketOffersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingBasketOfferDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalBlockingCodesBlockingCodeDto = {
    serializedName: "GlobalBlockingCodesBlockingCodeDto",
    type: {
        name: "Composite",
        className: "GlobalBlockingCodesBlockingCodeDto",
        modelProperties: {
            blockingCodeId: {
                required: true,
                serializedName: "BlockingCodeId",
                type: {
                    name: "Number"
                }
            },
            blockingType: {
                required: true,
                serializedName: "BlockingType",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            cvId: {
                serializedName: "CvId",
                type: {
                    name: "Number"
                }
            },
            notifyOnCancellation: {
                required: true,
                serializedName: "NotifyOnCancellation",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalBlockingCodesBlockingCodesDto = {
    serializedName: "GlobalBlockingCodesBlockingCodesDto",
    type: {
        name: "Composite",
        className: "GlobalBlockingCodesBlockingCodesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalBlockingCodesBlockingCodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersBlockingDto = {
    serializedName: "GlobalCustomersBlockingDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersBlockingDto",
        modelProperties: {
            blockingId: {
                required: true,
                serializedName: "BlockingId",
                type: {
                    name: "Number"
                }
            },
            validFrom: {
                required: true,
                serializedName: "ValidFrom",
                type: {
                    name: "DateTime"
                }
            },
            validTo: {
                required: true,
                serializedName: "ValidTo",
                type: {
                    name: "DateTime"
                }
            },
            blockingCodeId: {
                required: true,
                serializedName: "BlockingCodeId",
                type: {
                    name: "Number"
                }
            },
            imported: {
                required: true,
                serializedName: "Imported",
                type: {
                    name: "Boolean"
                }
            },
            orderId: {
                serializedName: "OrderId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersBlockingsDto = {
    serializedName: "GlobalCustomersBlockingsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersBlockingsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersBlockingDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedImageVariant = {
    serializedName: "GlobalSharedImageVariant",
    type: {
        name: "Composite",
        className: "GlobalSharedImageVariant",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            width: {
                required: true,
                serializedName: "Width",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSharedImage = {
    serializedName: "GlobalSharedImage",
    type: {
        name: "Composite",
        className: "GlobalSharedImage",
        modelProperties: {
            sizes: {
                required: true,
                serializedName: "Sizes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSharedImageVariant"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsSubBrandDto = {
    serializedName: "GlobalProductsSubBrandDto",
    type: {
        name: "Composite",
        className: "GlobalProductsSubBrandDto",
        modelProperties: {
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            subBrands: {
                required: true,
                serializedName: "SubBrands",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsSubBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsBrandDto = {
    serializedName: "GlobalProductsBrandDto",
    type: {
        name: "Composite",
        className: "GlobalProductsBrandDto",
        modelProperties: {
            productsCount: {
                serializedName: "ProductsCount",
                type: {
                    name: "Number"
                }
            },
            logo: {
                serializedName: "Logo",
                type: {
                    name: "Composite",
                    className: "GlobalSharedImage"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            subBrands: {
                required: true,
                serializedName: "SubBrands",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsSubBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsBrandsDto = {
    serializedName: "GlobalProductsBrandsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsBrandsDto",
        modelProperties: {
            brandsCollection: {
                required: true,
                serializedName: "BrandsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsBrandDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCallInteractionsCallInteractionDto = {
    serializedName: "GlobalCallInteractionsCallInteractionDto",
    type: {
        name: "Composite",
        className: "GlobalCallInteractionsCallInteractionDto",
        modelProperties: {
            callInteractionId: {
                required: true,
                serializedName: "CallInteractionId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            consultantNumber: {
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            callId: {
                serializedName: "CallId",
                type: {
                    name: "String"
                }
            },
            customerTelephoneNumber: {
                serializedName: "CustomerTelephoneNumber",
                type: {
                    name: "String"
                }
            },
            operatorTelephoneNumber: {
                serializedName: "OperatorTelephoneNumber",
                type: {
                    name: "String"
                }
            },
            callConnected: {
                serializedName: "CallConnected",
                type: {
                    name: "DateTime"
                }
            },
            callTerminated: {
                serializedName: "CallTerminated",
                type: {
                    name: "DateTime"
                }
            },
            operatorName: {
                serializedName: "OperatorName",
                type: {
                    name: "String"
                }
            },
            connectionDuration: {
                serializedName: "ConnectionDuration",
                type: {
                    name: "Number"
                }
            },
            queueWaitTime: {
                serializedName: "QueueWaitTime",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCampaignsCampaignPointsDto = {
    serializedName: "GlobalCampaignsCampaignPointsDto",
    type: {
        name: "Composite",
        className: "GlobalCampaignsCampaignPointsDto",
        modelProperties: {
            campaignId: {
                required: true,
                serializedName: "CampaignId",
                type: {
                    name: "Number"
                }
            },
            availablePoints: {
                required: true,
                serializedName: "AvailablePoints",
                type: {
                    name: "Number"
                }
            },
            expiringPoints: {
                required: true,
                serializedName: "ExpiringPoints",
                type: {
                    name: "Number"
                }
            },
            expiration: {
                required: true,
                serializedName: "Expiration",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalCampaignsCampaignDto = {
    serializedName: "GlobalCampaignsCampaignDto",
    type: {
        name: "Composite",
        className: "GlobalCampaignsCampaignDto",
        modelProperties: {
            id: {
                required: true,
                serializedName: "Id",
                type: {
                    name: "Number"
                }
            },
            category: {
                required: true,
                serializedName: "Category",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            isActive: {
                required: true,
                serializedName: "IsActive",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCampaignsCampaignsDto = {
    serializedName: "GlobalCampaignsCampaignsDto",
    type: {
        name: "Composite",
        className: "GlobalCampaignsCampaignsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCampaignsCampaignDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCampaignsCampaignStepScopeDto = {
    serializedName: "GlobalCampaignsCampaignStepScopeDto",
    type: {
        name: "Composite",
        className: "GlobalCampaignsCampaignStepScopeDto",
        modelProperties: {
            basedOn: {
                required: true,
                serializedName: "BasedOn",
                type: {
                    name: "String"
                }
            },
            scopeType: {
                required: true,
                serializedName: "ScopeType",
                type: {
                    name: "String"
                }
            },
            scope: {
                required: true,
                serializedName: "Scope",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCampaignsCampaignStepDto = {
    serializedName: "GlobalCampaignsCampaignStepDto",
    type: {
        name: "Composite",
        className: "GlobalCampaignsCampaignStepDto",
        modelProperties: {
            step: {
                required: true,
                serializedName: "Step",
                type: {
                    name: "Number"
                }
            },
            target: {
                required: true,
                serializedName: "Target",
                type: {
                    name: "Number"
                }
            },
            scope: {
                serializedName: "Scope",
                type: {
                    name: "Composite",
                    className: "GlobalCampaignsCampaignStepScopeDto"
                }
            }
        }
    }
};
export var GlobalCampaignsCampaignTargetsDto = {
    serializedName: "GlobalCampaignsCampaignTargetsDto",
    type: {
        name: "Composite",
        className: "GlobalCampaignsCampaignTargetsDto",
        modelProperties: {
            steps: {
                required: true,
                serializedName: "Steps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCampaignsCampaignStepDto"
                        }
                    }
                }
            },
            isConfigured: {
                required: true,
                serializedName: "IsConfigured",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalProductsCampaignBenefitDto = {
    serializedName: "GlobalProductsCampaignBenefitDto",
    type: {
        name: "Composite",
        className: "GlobalProductsCampaignBenefitDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            points: {
                required: true,
                serializedName: "Points",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsCampaignBenefitsDto = {
    serializedName: "GlobalProductsCampaignBenefitsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsCampaignBenefitsDto",
        modelProperties: {
            productsCampaignBenefitsCollection: {
                required: true,
                serializedName: "ProductsCampaignBenefitsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsCampaignBenefitDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCataloguesCataloguePageItemDto = {
    serializedName: "GlobalCataloguesCataloguePageItemDto",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCataloguePageItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            visualAspects: {
                required: true,
                serializedName: "VisualAspects",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCataloguesCataloguePage = {
    serializedName: "GlobalCataloguesCataloguePage",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCataloguePage",
        modelProperties: {
            pageIndex: {
                required: true,
                serializedName: "PageIndex",
                type: {
                    name: "Number"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            pageItems: {
                required: true,
                serializedName: "PageItems",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCataloguesCataloguePageItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCataloguesCatalogueContentDto = {
    serializedName: "GlobalCataloguesCatalogueContentDto",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCatalogueContentDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            cataloguePages: {
                required: true,
                serializedName: "CataloguePages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCataloguesCataloguePage"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCataloguesCatalogueItemDto = {
    serializedName: "GlobalCataloguesCatalogueItemDto",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCatalogueItemDto",
        modelProperties: {
            catalogueItemId: {
                serializedName: "CatalogueItemId",
                type: {
                    name: "String"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            isStandard: {
                required: true,
                serializedName: "IsStandard",
                type: {
                    name: "Boolean"
                }
            },
            pageNumber: {
                serializedName: "PageNumber",
                type: {
                    name: "Number"
                }
            },
            cataloguePrice: {
                required: true,
                serializedName: "CataloguePrice",
                type: {
                    name: "Number"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            points: {
                serializedName: "Points",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            bv: {
                required: true,
                serializedName: "Bv",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCataloguesCatalogueItemsDto = {
    serializedName: "GlobalCataloguesCatalogueItemsDto",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCatalogueItemsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCataloguesCatalogueItemDto"
                        }
                    }
                }
            },
            skip: {
                serializedName: "Skip",
                type: {
                    name: "Number"
                }
            },
            top: {
                serializedName: "Top",
                type: {
                    name: "Number"
                }
            },
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSharedDateTimeOffsetValidityDto = {
    serializedName: "GlobalSharedDateTimeOffsetValidityDto",
    type: {
        name: "Composite",
        className: "GlobalSharedDateTimeOffsetValidityDto",
        modelProperties: {
            from: {
                required: true,
                serializedName: "From",
                type: {
                    name: "DateTime"
                }
            },
            to: {
                required: true,
                serializedName: "To",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalCataloguesCatalogueDto = {
    serializedName: "GlobalCataloguesCatalogueDto",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCatalogueDto",
        modelProperties: {
            catalogueId: {
                required: true,
                serializedName: "CatalogueId",
                type: {
                    name: "Number"
                }
            },
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            typeCode: {
                serializedName: "TypeCode",
                type: {
                    name: "String"
                }
            },
            priority: {
                required: true,
                serializedName: "Priority",
                type: {
                    name: "Number"
                }
            },
            valid: {
                serializedName: "Valid",
                type: {
                    name: "Composite",
                    className: "GlobalSharedDateTimeOffsetValidityDto"
                }
            }
        }
    }
};
export var GlobalCataloguesCataloguesDto = {
    serializedName: "GlobalCataloguesCataloguesDto",
    type: {
        name: "Composite",
        className: "GlobalCataloguesCataloguesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCataloguesCatalogueDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSocialMediaLibraryCategoryDto = {
    serializedName: "GlobalSocialMediaLibraryCategoryDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibraryCategoryDto",
        modelProperties: {
            categoryId: {
                required: true,
                serializedName: "CategoryId",
                type: {
                    name: "Uuid"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            nameDefault: {
                serializedName: "NameDefault",
                type: {
                    name: "String"
                }
            },
            color: {
                serializedName: "Color",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibraryCategoriesDto = {
    serializedName: "GlobalSocialMediaLibraryCategoriesDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibraryCategoriesDto",
        modelProperties: {
            categoriesCollection: {
                required: true,
                serializedName: "CategoriesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSocialMediaLibraryCategoryDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsCategoryDto = {
    serializedName: "GlobalProductsCategoryDto",
    type: {
        name: "Composite",
        className: "GlobalProductsCategoryDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            shortTitle: {
                serializedName: "ShortTitle",
                type: {
                    name: "String"
                }
            },
            subCategories: {
                required: true,
                serializedName: "SubCategories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsCategoryDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsCategoriesDto = {
    serializedName: "GlobalProductsCategoriesDto",
    type: {
        name: "Composite",
        className: "GlobalProductsCategoriesDto",
        modelProperties: {
            categoriesCollection: {
                required: true,
                serializedName: "CategoriesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsCategoryDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalConceptsConceptLabelsDto = {
    serializedName: "GlobalConceptsConceptLabelsDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptLabelsDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            conceptLabelsCollection: {
                required: true,
                serializedName: "ConceptLabelsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalConceptsConceptsLabelsDto = {
    serializedName: "GlobalConceptsConceptsLabelsDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptsLabelsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalConceptsConceptLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedPagingDto = {
    serializedName: "GlobalSharedPagingDto",
    type: {
        name: "Composite",
        className: "GlobalSharedPagingDto",
        modelProperties: {
            top: {
                serializedName: "Top",
                type: {
                    name: "Number"
                }
            },
            skip: {
                serializedName: "Skip",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalConceptsSearchDto = {
    serializedName: "GlobalConceptsSearchDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsSearchDto",
        modelProperties: {
            searchTerm: {
                serializedName: "SearchTerm",
                type: {
                    name: "String"
                }
            },
            minimumSimilarity: {
                required: true,
                serializedName: "MinimumSimilarity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalConceptsQueryDto = {
    serializedName: "GlobalConceptsQueryDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsQueryDto",
        modelProperties: {
            conceptCodes: {
                serializedName: "ConceptCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            paging: {
                serializedName: "Paging",
                type: {
                    name: "Composite",
                    className: "GlobalSharedPagingDto"
                }
            },
            search: {
                serializedName: "Search",
                type: {
                    name: "Composite",
                    className: "GlobalConceptsSearchDto"
                }
            }
        }
    }
};
export var GlobalConceptsConceptDto = {
    serializedName: "GlobalConceptsConceptDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            brandId: {
                serializedName: "BrandId",
                type: {
                    name: "String"
                }
            },
            subBrandId: {
                serializedName: "SubBrandId",
                type: {
                    name: "String"
                }
            },
            activeIngredients: {
                serializedName: "ActiveIngredients",
                type: {
                    name: "String"
                }
            },
            ingredients: {
                serializedName: "Ingredients",
                type: {
                    name: "String"
                }
            },
            productStory: {
                serializedName: "ProductStory",
                type: {
                    name: "String"
                }
            },
            categoryIds: {
                required: true,
                serializedName: "CategoryIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            originalName: {
                serializedName: "OriginalName",
                type: {
                    name: "String"
                }
            },
            productDescription: {
                serializedName: "ProductDescription",
                type: {
                    name: "String"
                }
            },
            howToUse: {
                serializedName: "HowToUse",
                type: {
                    name: "String"
                }
            },
            isMultiProduct: {
                required: true,
                serializedName: "IsMultiProduct",
                type: {
                    name: "Boolean"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            hashCode: {
                required: true,
                serializedName: "HashCode",
                type: {
                    name: "Number"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productName: {
                serializedName: "ProductName",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            thumbnailImageUrl: {
                serializedName: "ThumbnailImageUrl",
                type: {
                    name: "String"
                }
            },
            isDiscontinued: {
                required: true,
                serializedName: "IsDiscontinued",
                type: {
                    name: "Boolean"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            isOutlet: {
                required: true,
                serializedName: "IsOutlet",
                type: {
                    name: "Boolean"
                }
            },
            ratingAverage: {
                required: true,
                serializedName: "RatingAverage",
                type: {
                    name: "Number"
                }
            },
            ratingCount: {
                required: true,
                serializedName: "RatingCount",
                type: {
                    name: "Number"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalConceptsConceptsDto = {
    serializedName: "GlobalConceptsConceptsDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptsDto",
        modelProperties: {
            conceptsCollection: {
                required: true,
                serializedName: "ConceptsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalConceptsConceptDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSharedAddThisServiceDto = {
    serializedName: "GlobalSharedAddThisServiceDto",
    type: {
        name: "Composite",
        className: "GlobalSharedAddThisServiceDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            cssClassName: {
                serializedName: "CssClassName",
                type: {
                    name: "String"
                }
            },
            jsClassName: {
                serializedName: "JsClassName",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedAddThisDto = {
    serializedName: "GlobalSharedAddThisDto",
    type: {
        name: "Composite",
        className: "GlobalSharedAddThisDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            services: {
                required: true,
                serializedName: "Services",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSharedAddThisServiceDto"
                        }
                    }
                }
            },
            sharedUrl: {
                serializedName: "SharedUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibraryConfigurationDto = {
    serializedName: "GlobalSocialMediaLibraryConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibraryConfigurationDto",
        modelProperties: {
            addThis: {
                serializedName: "AddThis",
                type: {
                    name: "Composite",
                    className: "GlobalSharedAddThisDto"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalApplicationsSharedLocalizationDto = {
    serializedName: "GlobalApplicationsSharedLocalizationDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSharedLocalizationDto",
        modelProperties: {
            defaultLanguage: {
                serializedName: "DefaultLanguage",
                type: {
                    name: "String"
                }
            },
            translations: {
                required: true,
                serializedName: "Translations",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Dictionary",
                            value: {
                                type: {
                                    name: "String"
                                }
                            }
                        }
                    }
                }
            },
            cultures: {
                required: true,
                serializedName: "Cultures",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "Object"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersConfirmationDto = {
    serializedName: "GlobalCustomersConfirmationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersConfirmationDto",
        modelProperties: {
            confirmationCode: {
                serializedName: "ConfirmationCode",
                type: {
                    name: "String"
                }
            },
            confirmationType: {
                required: true,
                serializedName: "ConfirmationType",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalLoginConnectedUserDto = {
    serializedName: "GlobalLoginConnectedUserDto",
    type: {
        name: "Composite",
        className: "GlobalLoginConnectedUserDto",
        modelProperties: {
            consultantNumber: {
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            tenant: {
                serializedName: "Tenant",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalConsultantsTitlesDto = {
    serializedName: "GlobalConsultantsTitlesDto",
    type: {
        name: "Composite",
        className: "GlobalConsultantsTitlesDto",
        modelProperties: {
            titles: {
                required: true,
                serializedName: "Titles",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAttributeValueDto = {
    serializedName: "GlobalCustomersAttributeValueDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAttributeValueDto",
        modelProperties: {
            value: {
                serializedName: "Value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersAttributeDto = {
    serializedName: "GlobalCustomersAttributeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAttributeDto",
        modelProperties: {
            customerAttributeTypeId: {
                required: true,
                serializedName: "CustomerAttributeTypeId",
                type: {
                    name: "Number"
                }
            },
            values: {
                required: true,
                serializedName: "Values",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAttributeValueDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAttributesDto = {
    serializedName: "GlobalCustomersAttributesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAttributesDto",
        modelProperties: {
            attributesCollection: {
                required: true,
                serializedName: "AttributesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAttributeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersDocumentAttributeDto = {
    serializedName: "GlobalCustomersDocumentAttributeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentAttributeDto",
        modelProperties: {
            documentId: {
                required: true,
                serializedName: "DocumentId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersDocumentsAttributeDto = {
    serializedName: "GlobalCustomersDocumentsAttributeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentsAttributeDto",
        modelProperties: {
            documentsCollection: {
                required: true,
                serializedName: "DocumentsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentAttributeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersBooleanAttributeDto = {
    serializedName: "GlobalCustomersBooleanAttributeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersBooleanAttributeDto",
        modelProperties: {
            value: {
                serializedName: "Value",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataAttributesMetadataDto = {
    serializedName: "GlobalCustomersMetadataAttributesMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataAttributesMetadataDto",
        modelProperties: {
            identityCard: {
                serializedName: "IdentityCard",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataDocumentPropertyDto"
                }
            },
            eInvoiceApproval: {
                serializedName: "EInvoiceApproval",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            }
        }
    }
};
export var GlobalCustomersWelcomeProgramStepDto = {
    serializedName: "GlobalCustomersWelcomeProgramStepDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersWelcomeProgramStepDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            target: {
                required: true,
                serializedName: "Target",
                type: {
                    name: "Number"
                }
            },
            isQualified: {
                required: true,
                serializedName: "IsQualified",
                type: {
                    name: "Boolean"
                }
            },
            isGiftTaken: {
                required: true,
                serializedName: "IsGiftTaken",
                type: {
                    name: "Boolean"
                }
            },
            missingSalesToQualify: {
                required: true,
                serializedName: "MissingSalesToQualify",
                type: {
                    name: "Number"
                }
            },
            missingPaidSalesToQualify: {
                serializedName: "MissingPaidSalesToQualify",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersWelcomeProgramDto = {
    serializedName: "GlobalCustomersWelcomeProgramDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersWelcomeProgramDto",
        modelProperties: {
            step: {
                required: true,
                serializedName: "Step",
                type: {
                    name: "Number"
                }
            },
            steps: {
                required: true,
                serializedName: "Steps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersWelcomeProgramStepDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersActivityProgramStepDto = {
    serializedName: "GlobalCustomersActivityProgramStepDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersActivityProgramStepDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            target: {
                required: true,
                serializedName: "Target",
                type: {
                    name: "Number"
                }
            },
            isQualified: {
                required: true,
                serializedName: "IsQualified",
                type: {
                    name: "Boolean"
                }
            },
            isGiftTaken: {
                required: true,
                serializedName: "IsGiftTaken",
                type: {
                    name: "Boolean"
                }
            },
            missingSalesForAcQualification: {
                required: true,
                serializedName: "MissingSalesForAcQualification",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersActivityProgramDto = {
    serializedName: "GlobalCustomersActivityProgramDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersActivityProgramDto",
        modelProperties: {
            step: {
                required: true,
                serializedName: "Step",
                type: {
                    name: "Number"
                }
            },
            steps: {
                required: true,
                serializedName: "Steps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersActivityProgramStepDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersRecruitmentCampaignDto = {
    serializedName: "GlobalCustomersRecruitmentCampaignDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRecruitmentCampaignDto",
        modelProperties: {
            earnedPoints: {
                required: true,
                serializedName: "EarnedPoints",
                type: {
                    name: "Number"
                }
            },
            availablePoints: {
                required: true,
                serializedName: "AvailablePoints",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersPersonalSalesDto = {
    serializedName: "GlobalCustomersPersonalSalesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPersonalSalesDto",
        modelProperties: {
            totalSales: {
                required: true,
                serializedName: "TotalSales",
                type: {
                    name: "Number"
                }
            },
            totalBpSales: {
                required: true,
                serializedName: "TotalBpSales",
                type: {
                    name: "Number"
                }
            },
            totalNormalSales: {
                required: true,
                serializedName: "TotalNormalSales",
                type: {
                    name: "Number"
                }
            },
            totalAmount: {
                required: true,
                serializedName: "TotalAmount",
                type: {
                    name: "Number"
                }
            },
            totalPaidSales: {
                required: true,
                serializedName: "TotalPaidSales",
                type: {
                    name: "Number"
                }
            },
            totalPaidBpSales: {
                required: true,
                serializedName: "TotalPaidBpSales",
                type: {
                    name: "Number"
                }
            },
            totalPaidNormalSales: {
                required: true,
                serializedName: "TotalPaidNormalSales",
                type: {
                    name: "Number"
                }
            },
            totalPaidAmount: {
                required: true,
                serializedName: "TotalPaidAmount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersPeriodPersonalSalesDto = {
    serializedName: "GlobalCustomersPeriodPersonalSalesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPeriodPersonalSalesDto",
        modelProperties: {
            periodCode: {
                required: true,
                serializedName: "PeriodCode",
                type: {
                    name: "Number"
                }
            },
            totalSales: {
                required: true,
                serializedName: "TotalSales",
                type: {
                    name: "Number"
                }
            },
            totalBpSales: {
                required: true,
                serializedName: "TotalBpSales",
                type: {
                    name: "Number"
                }
            },
            totalNormalSales: {
                required: true,
                serializedName: "TotalNormalSales",
                type: {
                    name: "Number"
                }
            },
            totalAmount: {
                required: true,
                serializedName: "TotalAmount",
                type: {
                    name: "Number"
                }
            },
            totalPaidSales: {
                required: true,
                serializedName: "TotalPaidSales",
                type: {
                    name: "Number"
                }
            },
            totalPaidBpSales: {
                required: true,
                serializedName: "TotalPaidBpSales",
                type: {
                    name: "Number"
                }
            },
            totalPaidNormalSales: {
                required: true,
                serializedName: "TotalPaidNormalSales",
                type: {
                    name: "Number"
                }
            },
            totalPaidAmount: {
                required: true,
                serializedName: "TotalPaidAmount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersCustomerPersonalSalesHistoryDto = {
    serializedName: "GlobalCustomersCustomerPersonalSalesHistoryDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersCustomerPersonalSalesHistoryDto",
        modelProperties: {
            sales: {
                required: true,
                serializedName: "Sales",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersPeriodPersonalSalesDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersLoyaltyProgramDto = {
    serializedName: "GlobalCustomersLoyaltyProgramDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersLoyaltyProgramDto",
        modelProperties: {
            balance: {
                required: true,
                serializedName: "Balance",
                type: {
                    name: "Number"
                }
            },
            toExpire: {
                required: true,
                serializedName: "ToExpire",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsProductLabelsDto = {
    serializedName: "GlobalProductsProductLabelsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductLabelsDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productsLabelsCollection: {
                required: true,
                serializedName: "ProductsLabelsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsProductsLabelsDto = {
    serializedName: "GlobalProductsProductsLabelsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductsLabelsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductLabelsDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalReportsCustomerStatusesRequestDto = {
    serializedName: "GlobalReportsCustomerStatusesRequestDto",
    type: {
        name: "Composite",
        className: "GlobalReportsCustomerStatusesRequestDto",
        modelProperties: {
            customerIds: {
                required: true,
                serializedName: "CustomerIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalReportsCustomerStatusRecordDto = {
    serializedName: "GlobalReportsCustomerStatusRecordDto",
    type: {
        name: "Composite",
        className: "GlobalReportsCustomerStatusRecordDto",
        modelProperties: {
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            isTerminated: {
                required: true,
                serializedName: "IsTerminated",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalReportsCustomerStatusesResponseDto = {
    serializedName: "GlobalReportsCustomerStatusesResponseDto",
    type: {
        name: "Composite",
        className: "GlobalReportsCustomerStatusesResponseDto",
        modelProperties: {
            records: {
                required: true,
                serializedName: "Records",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalReportsCustomerStatusRecordDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersLocalConsultantTitleDto = {
    serializedName: "GlobalCustomersLocalConsultantTitleDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersLocalConsultantTitleDto",
        modelProperties: {
            localConsultantTitle: {
                serializedName: "LocalConsultantTitle",
                type: {
                    name: "String"
                }
            },
            titleCode: {
                serializedName: "TitleCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersDeliveryAddressDto = {
    serializedName: "GlobalCustomersDeliveryAddressDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDeliveryAddressDto",
        modelProperties: {
            id: {
                required: true,
                serializedName: "Id",
                type: {
                    name: "Number"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            country: {
                serializedName: "Country",
                type: {
                    name: "String"
                }
            },
            region: {
                serializedName: "Region",
                type: {
                    name: "String"
                }
            },
            province: {
                serializedName: "Province",
                type: {
                    name: "String"
                }
            },
            district: {
                serializedName: "District",
                type: {
                    name: "String"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "String"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "String"
                }
            },
            locality: {
                serializedName: "Locality",
                type: {
                    name: "String"
                }
            },
            streetAddress: {
                serializedName: "StreetAddress",
                type: {
                    name: "String"
                }
            },
            zipcode: {
                serializedName: "Zipcode",
                type: {
                    name: "String"
                }
            },
            delivery: {
                serializedName: "Delivery",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalDeliveryDeliveryChannelDto = {
    serializedName: "GlobalDeliveryDeliveryChannelDto",
    type: {
        name: "Composite",
        className: "GlobalDeliveryDeliveryChannelDto",
        modelProperties: {
            deliveryChannelId: {
                required: true,
                serializedName: "DeliveryChannelId",
                type: {
                    name: "Number"
                }
            },
            orisalesId: {
                required: true,
                serializedName: "OrisalesId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            telephoneNumber: {
                serializedName: "TelephoneNumber",
                type: {
                    name: "String"
                }
            },
            isCodAllowed: {
                required: true,
                serializedName: "IsCodAllowed",
                type: {
                    name: "Boolean"
                }
            },
            isLuxury: {
                required: true,
                serializedName: "IsLuxury",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalSharedAddressDto = {
    serializedName: "GlobalSharedAddressDto",
    type: {
        name: "Composite",
        className: "GlobalSharedAddressDto",
        modelProperties: {
            addressId: {
                serializedName: "AddressId",
                type: {
                    name: "Number"
                }
            },
            addressType: {
                required: true,
                serializedName: "AddressType",
                type: {
                    name: "String"
                }
            },
            country: {
                serializedName: "Country",
                type: {
                    name: "String"
                }
            },
            region: {
                serializedName: "Region",
                type: {
                    name: "String"
                }
            },
            province: {
                serializedName: "Province",
                type: {
                    name: "String"
                }
            },
            district: {
                serializedName: "District",
                type: {
                    name: "String"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "String"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "String"
                }
            },
            locality: {
                serializedName: "Locality",
                type: {
                    name: "String"
                }
            },
            streetAddress: {
                serializedName: "StreetAddress",
                type: {
                    name: "String"
                }
            },
            zipcode: {
                serializedName: "Zipcode",
                type: {
                    name: "String"
                }
            },
            delivery: {
                serializedName: "Delivery",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingDeliveryChannelDto = {
    serializedName: "GlobalShoppingDeliveryChannelDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingDeliveryChannelDto",
        modelProperties: {
            deliveryChannelId: {
                required: true,
                serializedName: "DeliveryChannelId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            shippingFee: {
                required: true,
                serializedName: "ShippingFee",
                type: {
                    name: "Number"
                }
            },
            estimatedDelivery: {
                serializedName: "EstimatedDelivery",
                type: {
                    name: "DateTime"
                }
            },
            isCodAllowed: {
                required: true,
                serializedName: "IsCodAllowed",
                type: {
                    name: "Boolean"
                }
            },
            isAllowed: {
                required: true,
                serializedName: "IsAllowed",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalShoppingDeliveryChannelsDto = {
    serializedName: "GlobalShoppingDeliveryChannelsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingDeliveryChannelsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingDeliveryChannelDto"
                        }
                    }
                }
            },
            skip: {
                serializedName: "Skip",
                type: {
                    name: "Number"
                }
            },
            top: {
                serializedName: "Top",
                type: {
                    name: "Number"
                }
            },
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingDeliveryMethodDto = {
    serializedName: "GlobalShoppingDeliveryMethodDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingDeliveryMethodDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingDeliveryMethodsDto = {
    serializedName: "GlobalShoppingDeliveryMethodsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingDeliveryMethodsDto",
        modelProperties: {
            methodsCollection: {
                required: true,
                serializedName: "MethodsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingDeliveryMethodDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingDeliveryDto = {
    serializedName: "GlobalShoppingDeliveryDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingDeliveryDto",
        modelProperties: {
            deliveryChannelId: {
                required: true,
                serializedName: "DeliveryChannelId",
                type: {
                    name: "Number"
                }
            },
            addressId: {
                serializedName: "AddressId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalDeliveryDeliveryStatusDto = {
    serializedName: "GlobalDeliveryDeliveryStatusDto",
    type: {
        name: "Composite",
        className: "GlobalDeliveryDeliveryStatusDto",
        modelProperties: {
            deliveryStatus: {
                serializedName: "DeliveryStatus",
                type: {
                    name: "String"
                }
            },
            documentId: {
                serializedName: "DocumentId",
                type: {
                    name: "String"
                }
            },
            originalStatus: {
                serializedName: "OriginalStatus",
                type: {
                    name: "String"
                }
            },
            timeStamp: {
                required: true,
                serializedName: "TimeStamp",
                type: {
                    name: "DateTime"
                }
            },
            consultantNumber: {
                required: true,
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            phone: {
                serializedName: "Phone",
                type: {
                    name: "String"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "String"
                }
            },
            note: {
                serializedName: "Note",
                type: {
                    name: "String"
                }
            },
            numberOfPackages: {
                required: true,
                serializedName: "NumberOfPackages",
                type: {
                    name: "Number"
                }
            },
            reference: {
                serializedName: "Reference",
                type: {
                    name: "String"
                }
            },
            codAmountToBePaid: {
                serializedName: "CodAmountToBePaid",
                type: {
                    name: "Number"
                }
            },
            codAmountPaid: {
                serializedName: "CodAmountPaid",
                type: {
                    name: "Number"
                }
            },
            estimatedDeliveryDate: {
                serializedName: "EstimatedDeliveryDate",
                type: {
                    name: "DateTime"
                }
            },
            deliveryDate: {
                serializedName: "DeliveryDate",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalCustomersDocumentInfoDto = {
    serializedName: "GlobalCustomersDocumentInfoDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentInfoDto",
        modelProperties: {
            documentId: {
                required: true,
                serializedName: "DocumentId",
                type: {
                    name: "Number"
                }
            },
            fileName: {
                serializedName: "FileName",
                type: {
                    name: "String"
                }
            },
            fileSize: {
                required: true,
                serializedName: "FileSize",
                type: {
                    name: "Number"
                }
            },
            documentTypeId: {
                required: true,
                serializedName: "DocumentTypeId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            isActive: {
                required: true,
                serializedName: "IsActive",
                type: {
                    name: "Boolean"
                }
            },
            isTemporary: {
                required: true,
                serializedName: "IsTemporary",
                type: {
                    name: "Boolean"
                }
            },
            createdDate: {
                required: true,
                serializedName: "CreatedDate",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalCustomersDocumentTypeDto = {
    serializedName: "GlobalCustomersDocumentTypeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentTypeDto",
        modelProperties: {
            documentTypeId: {
                required: true,
                serializedName: "DocumentTypeId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            maxDataSize: {
                required: true,
                serializedName: "MaxDataSize",
                type: {
                    name: "Number"
                }
            },
            supportedMimeTypes: {
                serializedName: "SupportedMimeTypes",
                type: {
                    name: "String"
                }
            },
            documentTag: {
                required: true,
                serializedName: "DocumentTag",
                type: {
                    name: "String"
                }
            },
            documentCategory: {
                required: true,
                serializedName: "DocumentCategory",
                type: {
                    name: "String"
                }
            },
            allowMultipleDocuments: {
                required: true,
                serializedName: "AllowMultipleDocuments",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersDocumentApprovalProcessTypeDto = {
    serializedName: "GlobalCustomersDocumentApprovalProcessTypeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentApprovalProcessTypeDto",
        modelProperties: {
            automatic: {
                required: true,
                serializedName: "Automatic",
                type: {
                    name: "Boolean"
                }
            },
            manual: {
                required: true,
                serializedName: "Manual",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersDocumentApprovalDto = {
    serializedName: "GlobalCustomersDocumentApprovalDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentApprovalDto",
        modelProperties: {
            documentId: {
                required: true,
                serializedName: "DocumentId",
                type: {
                    name: "Number"
                }
            },
            documentIds: {
                required: true,
                serializedName: "DocumentIds",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Number"
                        }
                    }
                }
            },
            approvalState: {
                required: true,
                serializedName: "ApprovalState",
                type: {
                    name: "String"
                }
            },
            submittedDate: {
                serializedName: "SubmittedDate",
                type: {
                    name: "DateTime"
                }
            },
            reason: {
                serializedName: "Reason",
                type: {
                    name: "String"
                }
            },
            audited: {
                serializedName: "Audited",
                type: {
                    name: "Boolean"
                }
            },
            systemNote: {
                serializedName: "SystemNote",
                type: {
                    name: "String"
                }
            },
            processedBy: {
                serializedName: "ProcessedBy",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersDocumentApprovalProcessTypeDto"
                }
            }
        }
    }
};
export var GlobalCustomersDocumentApprovalsDto = {
    serializedName: "GlobalCustomersDocumentApprovalsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersDocumentApprovalsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentApprovalDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalKpisDownlinePerformanceDto = {
    serializedName: "GlobalKpisDownlinePerformanceDto",
    type: {
        name: "Composite",
        className: "GlobalKpisDownlinePerformanceDto",
        modelProperties: {
            earnings: {
                required: true,
                serializedName: "Earnings",
                type: {
                    name: "Number"
                }
            },
            splitOuts: {
                required: true,
                serializedName: "SplitOuts",
                type: {
                    name: "Number"
                }
            },
            performanceDiscount: {
                required: true,
                serializedName: "PerformanceDiscount",
                type: {
                    name: "Number"
                }
            },
            bonusPointsInPersonalGroup: {
                required: true,
                serializedName: "BonusPointsInPersonalGroup",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersEmailDto = {
    serializedName: "GlobalCustomersEmailDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersEmailDto",
        modelProperties: {
            emailAddress: {
                serializedName: "EmailAddress",
                type: {
                    name: "String"
                }
            },
            isPending: {
                required: true,
                serializedName: "IsPending",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersEmailsDto = {
    serializedName: "GlobalCustomersEmailsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersEmailsDto",
        modelProperties: {
            emails: {
                required: true,
                serializedName: "Emails",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersEmailDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersMetadataEmailMetadataDto = {
    serializedName: "GlobalCustomersMetadataEmailMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataEmailMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationsDto"
                }
            },
            emailAddress: {
                serializedName: "EmailAddress",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            }
        }
    }
};
export var GlobalEndConsumerOrdersEndConsumerOrderItemDto = {
    serializedName: "GlobalEndConsumerOrdersEndConsumerOrderItemDto",
    type: {
        name: "Composite",
        className: "GlobalEndConsumerOrdersEndConsumerOrderItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalEndConsumerOrdersEndConsumerOrderDto = {
    serializedName: "GlobalEndConsumerOrdersEndConsumerOrderDto",
    type: {
        name: "Composite",
        className: "GlobalEndConsumerOrdersEndConsumerOrderDto",
        modelProperties: {
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            endConsumerId: {
                required: true,
                serializedName: "EndConsumerId",
                type: {
                    name: "Number"
                }
            },
            endConsumerOrderType: {
                required: true,
                serializedName: "EndConsumerOrderType",
                type: {
                    name: "String"
                }
            },
            created: {
                required: true,
                serializedName: "Created",
                type: {
                    name: "DateTime"
                }
            },
            comment: {
                serializedName: "Comment",
                type: {
                    name: "String"
                }
            },
            endConsumerOrderId: {
                required: true,
                serializedName: "EndConsumerOrderId",
                type: {
                    name: "Number"
                }
            },
            endConsumerOrderStatus: {
                required: true,
                serializedName: "EndConsumerOrderStatus",
                type: {
                    name: "String"
                }
            },
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalEndConsumerOrdersEndConsumerOrderItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalEndConsumerOrdersEndConsumerOrdersDto = {
    serializedName: "GlobalEndConsumerOrdersEndConsumerOrdersDto",
    type: {
        name: "Composite",
        className: "GlobalEndConsumerOrdersEndConsumerOrdersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalEndConsumerOrdersEndConsumerOrderDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersEndConsumerDto = {
    serializedName: "GlobalCustomersEndConsumerDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersEndConsumerDto",
        modelProperties: {
            endConsumerId: {
                serializedName: "EndConsumerId",
                type: {
                    name: "Number"
                }
            },
            endConsumerType: {
                serializedName: "EndConsumerType",
                type: {
                    name: "String"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            phoneNumber: {
                serializedName: "PhoneNumber",
                type: {
                    name: "String"
                }
            },
            financialSetId: {
                required: true,
                serializedName: "FinancialSetId",
                type: {
                    name: "Number"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "GlobalSharedAddressDto"
                }
            }
        }
    }
};
export var GlobalCustomersEndConsumersDto = {
    serializedName: "GlobalCustomersEndConsumersDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersEndConsumersDto",
        modelProperties: {
            endConsumersCollection: {
                required: true,
                serializedName: "EndConsumersCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersEndConsumerDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedMetadataValidationNumberValidationDto = {
    serializedName: "GlobalSharedMetadataValidationNumberValidationDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataValidationNumberValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalSharedMetadataNumberPropertyDto = {
    serializedName: "GlobalSharedMetadataNumberPropertyDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataNumberPropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationNumberValidationDto"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataEndConsumerMetadataDto = {
    serializedName: "GlobalCustomersMetadataEndConsumerMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataEndConsumerMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationsDto"
                }
            },
            endConsumerType: {
                serializedName: "EndConsumerType",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataEnumPropertyDto"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            phoneNumber: {
                serializedName: "PhoneNumber",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            financialSetId: {
                serializedName: "FinancialSetId",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataNumberPropertyDto"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressMetadataDto"
                }
            }
        }
    }
};
export var GlobalCustomersEndCustomerDto = {
    serializedName: "GlobalCustomersEndCustomerDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersEndCustomerDto",
        modelProperties: {
            sponsorNumber: {
                serializedName: "SponsorNumber",
                type: {
                    name: "Number"
                }
            },
            password: {
                serializedName: "Password",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "String"
                }
            },
            taxCode: {
                serializedName: "TaxCode",
                type: {
                    name: "String"
                }
            },
            taxCode2: {
                serializedName: "TaxCode2",
                type: {
                    name: "String"
                }
            },
            passport: {
                serializedName: "Passport",
                type: {
                    name: "String"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "DateTime"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "String"
                }
            },
            confirmation1: {
                required: true,
                serializedName: "Confirmation1",
                type: {
                    name: "Boolean"
                }
            },
            confirmation2: {
                required: true,
                serializedName: "Confirmation2",
                type: {
                    name: "Boolean"
                }
            },
            preferredLanguage: {
                serializedName: "PreferredLanguage",
                type: {
                    name: "String"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "GlobalSharedAddressDto"
                }
            },
            approvals: {
                serializedName: "Approvals",
                type: {
                    name: "Composite",
                    className: "GlobalSharedApprovalDto"
                }
            },
            attributes: {
                serializedName: "Attributes",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersAttributesDto"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedMetadataValidationDateTimeValidationDto = {
    serializedName: "GlobalSharedMetadataValidationDateTimeValidationDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataValidationDateTimeValidationDto",
        modelProperties: {
            isMandatory: {
                required: true,
                serializedName: "IsMandatory",
                type: {
                    name: "Boolean"
                }
            },
            minValue: {
                serializedName: "MinValue",
                type: {
                    name: "DateTime"
                }
            },
            maxValue: {
                serializedName: "MaxValue",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalSharedMetadataDateTimePropertyDto = {
    serializedName: "GlobalSharedMetadataDateTimePropertyDto",
    type: {
        name: "Composite",
        className: "GlobalSharedMetadataDateTimePropertyDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isEditable: {
                required: true,
                serializedName: "IsEditable",
                type: {
                    name: "Boolean"
                }
            },
            validation: {
                serializedName: "Validation",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataValidationDateTimeValidationDto"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataEndCustomerMetadataDto = {
    serializedName: "GlobalCustomersMetadataEndCustomerMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataEndCustomerMetadataDto",
        modelProperties: {
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataAddressMetadataDto"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            taxCode: {
                serializedName: "TaxCode",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            taxCode2: {
                serializedName: "TaxCode2",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            passport: {
                serializedName: "Passport",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataDateTimePropertyDto"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            confirmation1: {
                serializedName: "Confirmation1",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            confirmation2: {
                serializedName: "Confirmation2",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            },
            preferredLanguage: {
                serializedName: "PreferredLanguage",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            approvals: {
                serializedName: "Approvals",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataCustomerApprovalMetadataDto"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataEnumPropertyDto"
                }
            },
            sponsorNumber: {
                serializedName: "SponsorNumber",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataNumberPropertyDto"
                }
            },
            password: {
                serializedName: "Password",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            }
        }
    }
};
export var GlobalSystemIdentityServerEndpointsDto = {
    serializedName: "GlobalSystemIdentityServerEndpointsDto",
    type: {
        name: "Composite",
        className: "GlobalSystemIdentityServerEndpointsDto",
        modelProperties: {
            identityUrl: {
                serializedName: "IdentityUrl",
                type: {
                    name: "String"
                }
            },
            apiUrl: {
                serializedName: "ApiUrl",
                type: {
                    name: "String"
                }
            },
            internalIdentityUrl: {
                serializedName: "InternalIdentityUrl",
                type: {
                    name: "String"
                }
            },
            internalApiUrl: {
                serializedName: "InternalApiUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSystemOnlineEndpointsDto = {
    serializedName: "GlobalSystemOnlineEndpointsDto",
    type: {
        name: "Composite",
        className: "GlobalSystemOnlineEndpointsDto",
        modelProperties: {
            onlineUrl: {
                serializedName: "OnlineUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersWeChatUnionIdDto = {
    serializedName: "GlobalCustomersWeChatUnionIdDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersWeChatUnionIdDto",
        modelProperties: {
            unionId: {
                serializedName: "UnionId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalAccountsExternalProfileDto = {
    serializedName: "GlobalAccountsExternalProfileDto",
    type: {
        name: "Composite",
        className: "GlobalAccountsExternalProfileDto",
        modelProperties: {
            externalProvider: {
                required: true,
                serializedName: "ExternalProvider",
                type: {
                    name: "String"
                }
            },
            pictureUrl: {
                serializedName: "PictureUrl",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            externalAccountId: {
                serializedName: "ExternalAccountId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersFinancialSetDto = {
    serializedName: "GlobalCustomersFinancialSetDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersFinancialSetDto",
        modelProperties: {
            financialSetId: {
                required: true,
                serializedName: "FinancialSetId",
                type: {
                    name: "Number"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            currencyName: {
                serializedName: "CurrencyName",
                type: {
                    name: "String"
                }
            },
            priceRounding: {
                required: true,
                serializedName: "PriceRounding",
                type: {
                    name: "Number"
                }
            },
            bvRounding: {
                required: true,
                serializedName: "BvRounding",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalApplicationsOriflameAppFrontPageBannerLinkDto = {
    serializedName: "GlobalApplicationsOriflameAppFrontPageBannerLinkDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsOriflameAppFrontPageBannerLinkDto",
        modelProperties: {
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            fontColor: {
                serializedName: "FontColor",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalApplicationsOriflameAppImageSizeDto = {
    serializedName: "GlobalApplicationsOriflameAppImageSizeDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsOriflameAppImageSizeDto",
        modelProperties: {
            width: {
                required: true,
                serializedName: "Width",
                type: {
                    name: "Number"
                }
            },
            height: {
                required: true,
                serializedName: "Height",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalApplicationsOriflameAppFrontPageBannerImageDto = {
    serializedName: "GlobalApplicationsOriflameAppFrontPageBannerImageDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsOriflameAppFrontPageBannerImageDto",
        modelProperties: {
            source: {
                serializedName: "Source",
                type: {
                    name: "String"
                }
            },
            createdDate: {
                required: true,
                serializedName: "CreatedDate",
                type: {
                    name: "DateTime"
                }
            },
            thumbUrl: {
                serializedName: "ThumbUrl",
                type: {
                    name: "String"
                }
            },
            size: {
                serializedName: "Size",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsOriflameAppImageSizeDto"
                }
            }
        }
    }
};
export var GlobalApplicationsOriflameAppFrontPageBannerDto = {
    serializedName: "GlobalApplicationsOriflameAppFrontPageBannerDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsOriflameAppFrontPageBannerDto",
        modelProperties: {
            frontPageBannerId: {
                serializedName: "FrontPageBannerId",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            tagline: {
                serializedName: "Tagline",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsOriflameAppFrontPageBannerLinkDto"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsOriflameAppFrontPageBannerImageDto"
                }
            }
        }
    }
};
export var GlobalApplicationsOriflameAppFrontPageBannersDto = {
    serializedName: "GlobalApplicationsOriflameAppFrontPageBannersDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsOriflameAppFrontPageBannersDto",
        modelProperties: {
            frontPageBannersCollection: {
                required: true,
                serializedName: "FrontPageBannersCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsOriflameAppFrontPageBannerDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersGrantedCreditDto = {
    serializedName: "GlobalCustomersGrantedCreditDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersGrantedCreditDto",
        modelProperties: {
            grantedCreditLimit: {
                required: true,
                serializedName: "GrantedCreditLimit",
                type: {
                    name: "Number"
                }
            },
            grantedCreditAuthorization: {
                required: true,
                serializedName: "GrantedCreditAuthorization",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersGuaranteeCreditDto = {
    serializedName: "GlobalCustomersGuaranteeCreditDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersGuaranteeCreditDto",
        modelProperties: {
            guaranteedAmount: {
                required: true,
                serializedName: "GuaranteedAmount",
                type: {
                    name: "Number"
                }
            },
            guaranteedCredits: {
                required: true,
                serializedName: "GuaranteedCredits",
                type: {
                    name: "Number"
                }
            },
            guaranteeCredit: {
                required: true,
                serializedName: "GuaranteeCredit",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalGuaranteeCreditGrantedCreditConfigurationDto = {
    serializedName: "GlobalGuaranteeCreditGrantedCreditConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalGuaranteeCreditGrantedCreditConfigurationDto",
        modelProperties: {
            permanentCreditAllowed: {
                required: true,
                serializedName: "PermanentCreditAllowed",
                type: {
                    name: "Boolean"
                }
            },
            permanentCreditLimit: {
                required: true,
                serializedName: "PermanentCreditLimit",
                type: {
                    name: "Number"
                }
            },
            oneTimeCreditAllowed: {
                required: true,
                serializedName: "OneTimeCreditAllowed",
                type: {
                    name: "Boolean"
                }
            },
            oneTimeCreditLimit: {
                required: true,
                serializedName: "OneTimeCreditLimit",
                type: {
                    name: "Number"
                }
            },
            checkGuarantorRemainingCredit: {
                required: true,
                serializedName: "CheckGuarantorRemainingCredit",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalShoppingHomeDeliveryOptionDto = {
    serializedName: "GlobalShoppingHomeDeliveryOptionDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingHomeDeliveryOptionDto",
        modelProperties: {
            addressId: {
                required: true,
                serializedName: "AddressId",
                type: {
                    name: "Number"
                }
            },
            allowedChannels: {
                required: true,
                serializedName: "AllowedChannels",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingDeliveryChannelDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingHomeDeliveryOptionsDto = {
    serializedName: "GlobalShoppingHomeDeliveryOptionsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingHomeDeliveryOptionsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingHomeDeliveryOptionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSocialMediaLibraryImageSizeDto = {
    serializedName: "GlobalSocialMediaLibraryImageSizeDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibraryImageSizeDto",
        modelProperties: {
            width: {
                required: true,
                serializedName: "Width",
                type: {
                    name: "Number"
                }
            },
            height: {
                required: true,
                serializedName: "Height",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibraryImageInfoDto = {
    serializedName: "GlobalSocialMediaLibraryImageInfoDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibraryImageInfoDto",
        modelProperties: {
            imageInfoId: {
                required: true,
                serializedName: "ImageInfoId",
                type: {
                    name: "Uuid"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            source: {
                serializedName: "Source",
                type: {
                    name: "String"
                }
            },
            isPopular: {
                required: true,
                serializedName: "IsPopular",
                type: {
                    name: "Boolean"
                }
            },
            createdDate: {
                required: true,
                serializedName: "CreatedDate",
                type: {
                    name: "DateTime"
                }
            },
            size: {
                serializedName: "Size",
                type: {
                    name: "Composite",
                    className: "GlobalSocialMediaLibraryImageSizeDto"
                }
            },
            categories: {
                required: true,
                serializedName: "Categories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Uuid"
                        }
                    }
                }
            },
            thumbUrl: {
                serializedName: "ThumbUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibraryImageInfosDto = {
    serializedName: "GlobalSocialMediaLibraryImageInfosDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibraryImageInfosDto",
        modelProperties: {
            imageInfosCollection: {
                required: true,
                serializedName: "ImageInfosCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSocialMediaLibraryImageInfoDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalNotificationsInAppNotificationActionDto = {
    serializedName: "GlobalNotificationsInAppNotificationActionDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsInAppNotificationActionDto",
        modelProperties: {
            actionType: {
                required: true,
                serializedName: "ActionType",
                type: {
                    name: "String"
                }
            },
            data: {
                required: true,
                serializedName: "Data",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalNotificationsInAppNotificationDto = {
    serializedName: "GlobalNotificationsInAppNotificationDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsInAppNotificationDto",
        modelProperties: {
            notificationType: {
                required: true,
                serializedName: "NotificationType",
                type: {
                    name: "String"
                }
            },
            notificationId: {
                serializedName: "NotificationId",
                type: {
                    name: "String"
                }
            },
            isViewed: {
                required: true,
                serializedName: "IsViewed",
                type: {
                    name: "Boolean"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            body: {
                serializedName: "Body",
                type: {
                    name: "String"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "String"
                }
            },
            actions: {
                required: true,
                serializedName: "Actions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNotificationsInAppNotificationActionDto"
                        }
                    }
                }
            },
            timestamp: {
                required: true,
                serializedName: "Timestamp",
                type: {
                    name: "DateTime"
                }
            },
            isDeleted: {
                required: true,
                serializedName: "IsDeleted",
                type: {
                    name: "Boolean"
                }
            },
            updatedAt: {
                required: true,
                serializedName: "UpdatedAt",
                type: {
                    name: "DateTime"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            isPopup: {
                required: true,
                serializedName: "IsPopup",
                type: {
                    name: "Boolean"
                }
            },
            popupBody: {
                serializedName: "PopupBody",
                type: {
                    name: "String"
                }
            },
            popupImage: {
                serializedName: "PopupImage",
                type: {
                    name: "String"
                }
            },
            popupExpirationDate: {
                serializedName: "PopupExpirationDate",
                type: {
                    name: "DateTime"
                }
            },
            messageType: {
                serializedName: "MessageType",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalNotificationsInAppNotificationsDto = {
    serializedName: "GlobalNotificationsInAppNotificationsDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsInAppNotificationsDto",
        modelProperties: {
            notifications: {
                required: true,
                serializedName: "Notifications",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNotificationsInAppNotificationDto"
                        }
                    }
                }
            },
            hasMoreResults: {
                required: true,
                serializedName: "HasMoreResults",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalNotificationsNotificationMessageTypeDto = {
    serializedName: "GlobalNotificationsNotificationMessageTypeDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsNotificationMessageTypeDto",
        modelProperties: {
            messageTypeId: {
                required: true,
                serializedName: "MessageTypeId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            isHidden: {
                required: true,
                serializedName: "IsHidden",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalNotificationsNotificationMessageTypesDto = {
    serializedName: "GlobalNotificationsNotificationMessageTypesDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsNotificationMessageTypesDto",
        modelProperties: {
            messageTypes: {
                required: true,
                serializedName: "MessageTypes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNotificationsNotificationMessageTypeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalIngredientLibraryIngredientDto = {
    serializedName: "GlobalIngredientLibraryIngredientDto",
    type: {
        name: "Composite",
        className: "GlobalIngredientLibraryIngredientDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            },
            shortName: {
                serializedName: "ShortName",
                type: {
                    name: "String"
                }
            },
            latinName: {
                serializedName: "LatinName",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            keyBenefit1: {
                serializedName: "KeyBenefit1",
                type: {
                    name: "String"
                }
            },
            keyBenefit2: {
                serializedName: "KeyBenefit2",
                type: {
                    name: "String"
                }
            },
            keyBenefit3: {
                serializedName: "KeyBenefit3",
                type: {
                    name: "String"
                }
            },
            didYouKnow: {
                serializedName: "DidYouKnow",
                type: {
                    name: "String"
                }
            },
            benefitSummary: {
                serializedName: "BenefitSummary",
                type: {
                    name: "String"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalIngredientLibraryIngredientsDto = {
    serializedName: "GlobalIngredientLibraryIngredientsDto",
    type: {
        name: "Composite",
        className: "GlobalIngredientLibraryIngredientsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalIngredientLibraryIngredientDto"
                        }
                    }
                }
            },
            skip: {
                serializedName: "Skip",
                type: {
                    name: "Number"
                }
            },
            top: {
                serializedName: "Top",
                type: {
                    name: "Number"
                }
            },
            totalRecords: {
                required: true,
                serializedName: "TotalRecords",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersJoiningFeeDialogHtmlDto = {
    serializedName: "GlobalCustomersJoiningFeeDialogHtmlDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersJoiningFeeDialogHtmlDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            imageText: {
                serializedName: "ImageText",
                type: {
                    name: "String"
                }
            },
            productLabel: {
                serializedName: "ProductLabel",
                type: {
                    name: "String"
                }
            },
            productPrice: {
                serializedName: "ProductPrice",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalAddressesLookupAddressNodeDto = {
    serializedName: "GlobalAddressesLookupAddressNodeDto",
    type: {
        name: "Composite",
        className: "GlobalAddressesLookupAddressNodeDto",
        modelProperties: {
            nodeId: {
                serializedName: "NodeId",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            country: {
                serializedName: "Country",
                type: {
                    name: "String"
                }
            },
            region: {
                serializedName: "Region",
                type: {
                    name: "String"
                }
            },
            province: {
                serializedName: "Province",
                type: {
                    name: "String"
                }
            },
            district: {
                serializedName: "District",
                type: {
                    name: "String"
                }
            },
            area: {
                serializedName: "Area",
                type: {
                    name: "String"
                }
            },
            city: {
                serializedName: "City",
                type: {
                    name: "String"
                }
            },
            locality: {
                serializedName: "Locality",
                type: {
                    name: "String"
                }
            },
            street: {
                serializedName: "Street",
                type: {
                    name: "String"
                }
            },
            zipCode: {
                serializedName: "ZipCode",
                type: {
                    name: "String"
                }
            },
            buildingDetails: {
                serializedName: "BuildingDetails",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalAddressesLookupAddressNodesDto = {
    serializedName: "GlobalAddressesLookupAddressNodesDto",
    type: {
        name: "Composite",
        className: "GlobalAddressesLookupAddressNodesDto",
        modelProperties: {
            addressNodesCollection: {
                required: true,
                serializedName: "AddressNodesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalAddressesLookupAddressNodeDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalAddressesLookupAddressSuggestionDto = {
    serializedName: "GlobalAddressesLookupAddressSuggestionDto",
    type: {
        name: "Composite",
        className: "GlobalAddressesLookupAddressSuggestionDto",
        modelProperties: {
            addressNodeId: {
                serializedName: "AddressNodeId",
                type: {
                    name: "String"
                }
            },
            pathKey: {
                serializedName: "PathKey",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            addressSummary: {
                serializedName: "AddressSummary",
                type: {
                    name: "String"
                }
            },
            suggestionType: {
                required: true,
                serializedName: "SuggestionType",
                type: {
                    name: "String"
                }
            },
            count: {
                required: true,
                serializedName: "Count",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalAddressesLookupAddressSuggestionsDto = {
    serializedName: "GlobalAddressesLookupAddressSuggestionsDto",
    type: {
        name: "Composite",
        className: "GlobalAddressesLookupAddressSuggestionsDto",
        modelProperties: {
            addressSuggestionsCollection: {
                required: true,
                serializedName: "AddressSuggestionsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalAddressesLookupAddressSuggestionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardLookDto = {
    serializedName: "GlobalApplicationsMakeUpWizardLookDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardLookDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "String"
                }
            },
            definition: {
                serializedName: "Definition",
                type: {
                    name: "String"
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardLooksDto = {
    serializedName: "GlobalApplicationsMakeUpWizardLooksDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardLooksDto",
        modelProperties: {
            looks: {
                required: true,
                serializedName: "Looks",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsMakeUpWizardLookDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardTagsDto = {
    serializedName: "GlobalApplicationsMakeUpWizardTagsDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardTagsDto",
        modelProperties: {
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardMakeupWizardMapDto = {
    serializedName: "GlobalApplicationsMakeUpWizardMakeupWizardMapDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardMakeupWizardMapDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            shiShiProductId: {
                serializedName: "ShiShiProductId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardMakeupWizardCategoryDto = {
    serializedName: "GlobalApplicationsMakeUpWizardMakeupWizardCategoryDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardMakeupWizardCategoryDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsMakeUpWizardMakeupWizardMapDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardMakeupWizardCategoriesDto = {
    serializedName: "GlobalApplicationsMakeUpWizardMakeupWizardCategoriesDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardMakeupWizardCategoriesDto",
        modelProperties: {
            categories: {
                required: true,
                serializedName: "Categories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsMakeUpWizardMakeupWizardCategoryDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardWelcomeScreenStepDto = {
    serializedName: "GlobalApplicationsMakeUpWizardWelcomeScreenStepDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardWelcomeScreenStepDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            stepType: {
                serializedName: "StepType",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            instructions: {
                serializedName: "Instructions",
                type: {
                    name: "String"
                }
            },
            buttonText: {
                serializedName: "ButtonText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardMakeupWizardPopUpDto = {
    serializedName: "GlobalApplicationsMakeUpWizardMakeupWizardPopUpDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardMakeupWizardPopUpDto",
        modelProperties: {
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            instructions: {
                serializedName: "Instructions",
                type: {
                    name: "String"
                }
            },
            definition: {
                serializedName: "Definition",
                type: {
                    name: "String"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalApplicationsMakeUpWizardWelcomeScreenStepsDto = {
    serializedName: "GlobalApplicationsMakeUpWizardWelcomeScreenStepsDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsMakeUpWizardWelcomeScreenStepsDto",
        modelProperties: {
            steps: {
                required: true,
                serializedName: "Steps",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsMakeUpWizardWelcomeScreenStepDto"
                        }
                    }
                }
            },
            makeupWizardPopUp: {
                serializedName: "MakeupWizardPopUp",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsMakeUpWizardMakeupWizardPopUpDto"
                }
            }
        }
    }
};
export var GlobalCommissionPlansTitleLegConditionDto = {
    serializedName: "GlobalCommissionPlansTitleLegConditionDto",
    type: {
        name: "Composite",
        className: "GlobalCommissionPlansTitleLegConditionDto",
        modelProperties: {
            legTitle: {
                serializedName: "LegTitle",
                type: {
                    name: "String"
                }
            },
            legTitleId: {
                required: true,
                serializedName: "LegTitleId",
                type: {
                    name: "Number"
                }
            },
            legCount: {
                required: true,
                serializedName: "LegCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCommissionPlansTitleQualificationParametersDto = {
    serializedName: "GlobalCommissionPlansTitleQualificationParametersDto",
    type: {
        name: "Composite",
        className: "GlobalCommissionPlansTitleQualificationParametersDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            titleId: {
                required: true,
                serializedName: "TitleId",
                type: {
                    name: "Number"
                }
            },
            pBp: {
                required: true,
                serializedName: "PBp",
                type: {
                    name: "Number"
                }
            },
            totalBp: {
                required: true,
                serializedName: "TotalBp",
                type: {
                    name: "Number"
                }
            },
            bonusQualifiedLegs: {
                required: true,
                serializedName: "BonusQualifiedLegs",
                type: {
                    name: "Number"
                }
            },
            titleLegConditions: {
                required: true,
                serializedName: "TitleLegConditions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCommissionPlansTitleLegConditionDto"
                        }
                    }
                }
            },
            titleQualifiedLegs: {
                required: true,
                serializedName: "TitleQualifiedLegs",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCommissionPlansTitleQualificationsMmDto = {
    serializedName: "GlobalCommissionPlansTitleQualificationsMmDto",
    type: {
        name: "Composite",
        className: "GlobalCommissionPlansTitleQualificationsMmDto",
        modelProperties: {
            periodId: {
                required: true,
                serializedName: "PeriodId",
                type: {
                    name: "Number"
                }
            },
            parameterVersion: {
                required: true,
                serializedName: "ParameterVersion",
                type: {
                    name: "Number"
                }
            },
            titleQualifications: {
                required: true,
                serializedName: "TitleQualifications",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCommissionPlansTitleQualificationParametersDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalMobileOfficeNameBankNameBankContactDto = {
    serializedName: "GlobalMobileOfficeNameBankNameBankContactDto",
    type: {
        name: "Composite",
        className: "GlobalMobileOfficeNameBankNameBankContactDto",
        modelProperties: {
            contactId: {
                serializedName: "ContactId",
                type: {
                    name: "Number"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            interestedIn: {
                required: true,
                serializedName: "InterestedIn",
                type: {
                    name: "String"
                }
            },
            isContacted: {
                required: true,
                serializedName: "IsContacted",
                type: {
                    name: "Boolean"
                }
            },
            phoneNumber: {
                serializedName: "PhoneNumber",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            note: {
                serializedName: "Note",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalMobileOfficeNameBankNameBankContactsDto = {
    serializedName: "GlobalMobileOfficeNameBankNameBankContactsDto",
    type: {
        name: "Composite",
        className: "GlobalMobileOfficeNameBankNameBankContactsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalMobileOfficeNameBankNameBankContactDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalNavigationNavigationItemDto = {
    serializedName: "GlobalNavigationNavigationItemDto",
    type: {
        name: "Composite",
        className: "GlobalNavigationNavigationItemDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            linkType: {
                required: true,
                serializedName: "LinkType",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            children: {
                required: true,
                serializedName: "Children",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNavigationNavigationItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalNavigationNavigationCollectionDto = {
    serializedName: "GlobalNavigationNavigationCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalNavigationNavigationCollectionDto",
        modelProperties: {
            navigationCollection: {
                required: true,
                serializedName: "NavigationCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNavigationNavigationItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalNavigationNavigationTagDto = {
    serializedName: "GlobalNavigationNavigationTagDto",
    type: {
        name: "Composite",
        className: "GlobalNavigationNavigationTagDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNavigationNavigationTagsCollectionDto = {
    serializedName: "GlobalNavigationNavigationTagsCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalNavigationNavigationTagsCollectionDto",
        modelProperties: {
            tagsCollection: {
                required: true,
                serializedName: "TagsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNavigationNavigationTagDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCmsArticleTeaserDto = {
    serializedName: "GlobalCmsArticleTeaserDto",
    type: {
        name: "Composite",
        className: "GlobalCmsArticleTeaserDto",
        modelProperties: {
            publishDate: {
                required: true,
                serializedName: "PublishDate",
                type: {
                    name: "DateTime"
                }
            },
            header: {
                serializedName: "Header",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            thumbnail: {
                serializedName: "Thumbnail",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCmsArticleTeasersDto = {
    serializedName: "GlobalCmsArticleTeasersDto",
    type: {
        name: "Composite",
        className: "GlobalCmsArticleTeasersDto",
        modelProperties: {
            articlesCollection: {
                required: true,
                serializedName: "ArticlesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCmsArticleTeaserDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalNotificationsMobileNotificationActionDto = {
    serializedName: "GlobalNotificationsMobileNotificationActionDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsMobileNotificationActionDto",
        modelProperties: {
            actionType: {
                required: true,
                serializedName: "ActionType",
                type: {
                    name: "String"
                }
            },
            data: {
                required: true,
                serializedName: "Data",
                type: {
                    name: "Dictionary",
                    value: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalNotificationsMobileNotificationDto = {
    serializedName: "GlobalNotificationsMobileNotificationDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsMobileNotificationDto",
        modelProperties: {
            batchId: {
                serializedName: "BatchId",
                type: {
                    name: "String"
                }
            },
            recipientId: {
                required: true,
                serializedName: "RecipientId",
                type: {
                    name: "String"
                }
            },
            languageId: {
                required: true,
                serializedName: "LanguageId",
                type: {
                    name: "String"
                }
            },
            clientApplication: {
                required: true,
                serializedName: "ClientApplication",
                type: {
                    name: "String"
                }
            },
            isPushNotification: {
                required: true,
                serializedName: "IsPushNotification",
                type: {
                    name: "Boolean"
                }
            },
            title: {
                required: true,
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            body: {
                required: true,
                serializedName: "Body",
                type: {
                    name: "String"
                }
            },
            pushBody: {
                serializedName: "PushBody",
                type: {
                    name: "String"
                }
            },
            notificationTypeId: {
                serializedName: "NotificationTypeId",
                type: {
                    name: "String"
                }
            },
            messageTypeId: {
                serializedName: "MessageTypeId",
                type: {
                    name: "Number"
                }
            },
            actions: {
                required: true,
                serializedName: "Actions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNotificationsMobileNotificationActionDto"
                        }
                    }
                }
            },
            isPopup: {
                serializedName: "IsPopup",
                type: {
                    name: "Boolean"
                }
            },
            popupBody: {
                serializedName: "PopupBody",
                type: {
                    name: "String"
                }
            },
            popupImage: {
                serializedName: "PopupImage",
                type: {
                    name: "String"
                }
            },
            popupExpirationDate: {
                serializedName: "PopupExpirationDate",
                type: {
                    name: "DateTime"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "String"
                }
            },
            useUtm: {
                serializedName: "UseUtm",
                type: {
                    name: "Boolean"
                }
            },
            campaign: {
                serializedName: "Campaign",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNotificationsMobileTemplateDto = {
    serializedName: "GlobalNotificationsMobileTemplateDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsMobileTemplateDto",
        modelProperties: {
            notificationTemplateId: {
                serializedName: "NotificationTemplateId",
                type: {
                    name: "String"
                }
            },
            languageId: {
                required: true,
                serializedName: "LanguageId",
                type: {
                    name: "String"
                }
            },
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            notificationTypeId: {
                serializedName: "NotificationTypeId",
                type: {
                    name: "String"
                }
            },
            messageType: {
                serializedName: "MessageType",
                type: {
                    name: "Number"
                }
            },
            clientApplicationId: {
                required: true,
                serializedName: "ClientApplicationId",
                type: {
                    name: "String"
                }
            },
            isPopup: {
                serializedName: "IsPopup",
                type: {
                    name: "Boolean"
                }
            },
            popupBody: {
                serializedName: "PopupBody",
                type: {
                    name: "String"
                }
            },
            popupImage: {
                serializedName: "PopupImage",
                type: {
                    name: "String"
                }
            },
            popupExpirationDate: {
                serializedName: "PopupExpirationDate",
                type: {
                    name: "DateTime"
                }
            },
            isPushNotification: {
                required: true,
                serializedName: "IsPushNotification",
                type: {
                    name: "Boolean"
                }
            },
            title: {
                required: true,
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            subtitle: {
                serializedName: "Subtitle",
                type: {
                    name: "String"
                }
            },
            image: {
                serializedName: "Image",
                type: {
                    name: "String"
                }
            },
            body: {
                serializedName: "Body",
                type: {
                    name: "String"
                }
            },
            pushBody: {
                serializedName: "PushBody",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNotificationsSmsTemplateDto = {
    serializedName: "GlobalNotificationsSmsTemplateDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsSmsTemplateDto",
        modelProperties: {
            notificationTemplateId: {
                serializedName: "NotificationTemplateId",
                type: {
                    name: "String"
                }
            },
            languageId: {
                required: true,
                serializedName: "LanguageId",
                type: {
                    name: "String"
                }
            },
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            body: {
                required: true,
                serializedName: "Body",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNotificationsEmailTemplateDto = {
    serializedName: "GlobalNotificationsEmailTemplateDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsEmailTemplateDto",
        modelProperties: {
            notificationTemplateId: {
                serializedName: "NotificationTemplateId",
                type: {
                    name: "String"
                }
            },
            languageId: {
                required: true,
                serializedName: "LanguageId",
                type: {
                    name: "String"
                }
            },
            isEnabled: {
                required: true,
                serializedName: "IsEnabled",
                type: {
                    name: "Boolean"
                }
            },
            subject: {
                required: true,
                serializedName: "Subject",
                type: {
                    name: "String"
                }
            },
            body: {
                required: true,
                serializedName: "Body",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNotificationsCustomerNotificationDto = {
    serializedName: "GlobalNotificationsCustomerNotificationDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsCustomerNotificationDto",
        modelProperties: {
            notificationId: {
                serializedName: "NotificationId",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            target: {
                required: true,
                serializedName: "Target",
                type: {
                    name: "String"
                }
            },
            consultantNumbers: {
                required: true,
                serializedName: "ConsultantNumbers",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            mobileTemplate: {
                serializedName: "MobileTemplate",
                type: {
                    name: "Composite",
                    className: "GlobalNotificationsMobileTemplateDto"
                }
            },
            smsTemplate: {
                serializedName: "SmsTemplate",
                type: {
                    name: "Composite",
                    className: "GlobalNotificationsSmsTemplateDto"
                }
            },
            emailTemplate: {
                serializedName: "EmailTemplate",
                type: {
                    name: "Composite",
                    className: "GlobalNotificationsEmailTemplateDto"
                }
            },
            modifiedAt: {
                serializedName: "ModifiedAt",
                type: {
                    name: "DateTime"
                }
            },
            sentAt: {
                serializedName: "SentAt",
                type: {
                    name: "DateTime"
                }
            },
            deliveredAt: {
                serializedName: "DeliveredAt",
                type: {
                    name: "DateTime"
                }
            },
            status: {
                required: true,
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            scheduledTime: {
                serializedName: "ScheduledTime",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalNotificationsCustomerNotificationSearchRequestDto = {
    serializedName: "GlobalNotificationsCustomerNotificationSearchRequestDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsCustomerNotificationSearchRequestDto",
        modelProperties: {
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            status: {
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            continueToken: {
                serializedName: "ContinueToken",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNotificationsCustomerNotificationSearchResultItemDto = {
    serializedName: "GlobalNotificationsCustomerNotificationSearchResultItemDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsCustomerNotificationSearchResultItemDto",
        modelProperties: {
            notificationId: {
                serializedName: "NotificationId",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            target: {
                required: true,
                serializedName: "Target",
                type: {
                    name: "String"
                }
            },
            modifiedAt: {
                serializedName: "ModifiedAt",
                type: {
                    name: "DateTime"
                }
            },
            sentAt: {
                serializedName: "SentAt",
                type: {
                    name: "DateTime"
                }
            },
            deliveredAt: {
                serializedName: "DeliveredAt",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalNotificationsCustomerNotificationSearchResultDto = {
    serializedName: "GlobalNotificationsCustomerNotificationSearchResultDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsCustomerNotificationSearchResultDto",
        modelProperties: {
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNotificationsCustomerNotificationSearchResultItemDto"
                        }
                    }
                }
            },
            continuationToken: {
                serializedName: "ContinuationToken",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalNotificationsTargetDescriptionDto = {
    serializedName: "GlobalNotificationsTargetDescriptionDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsTargetDescriptionDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            displayName: {
                serializedName: "DisplayName",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            targetEventCustomer: {
                required: true,
                serializedName: "TargetEventCustomer",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalNotificationsTargetCollectionDto = {
    serializedName: "GlobalNotificationsTargetCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsTargetCollectionDto",
        modelProperties: {
            targetDescriptions: {
                required: true,
                serializedName: "TargetDescriptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalNotificationsTargetDescriptionDto"
                        }
                    }
                }
            },
            isBonusServerAvailable: {
                required: true,
                serializedName: "IsBonusServerAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalShoppingOfferChoiceDto = {
    serializedName: "GlobalShoppingOfferChoiceDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferChoiceDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingOfferChoicesDto = {
    serializedName: "GlobalShoppingOfferChoicesDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferChoicesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOfferChoiceDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingOfferItemDto = {
    serializedName: "GlobalShoppingOfferItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            amount: {
                required: true,
                serializedName: "Amount",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            points: {
                required: true,
                serializedName: "Points",
                type: {
                    name: "Number"
                }
            },
            maxQuantityToBuy: {
                serializedName: "MaxQuantityToBuy",
                type: {
                    name: "Number"
                }
            },
            isValid: {
                required: true,
                serializedName: "IsValid",
                type: {
                    name: "Boolean"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingOfferItemsDto = {
    serializedName: "GlobalShoppingOfferItemsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferItemsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOfferItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingOfferDto = {
    serializedName: "GlobalShoppingOfferDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOfferDto",
        modelProperties: {
            offerId: {
                required: true,
                serializedName: "OfferId",
                type: {
                    name: "Number"
                }
            },
            correlationId: {
                serializedName: "CorrelationId",
                type: {
                    name: "Number"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            layout: {
                required: true,
                serializedName: "Layout",
                type: {
                    name: "String"
                }
            },
            availablePoints: {
                serializedName: "AvailablePoints",
                type: {
                    name: "Number"
                }
            },
            availableUnits: {
                serializedName: "AvailableUnits",
                type: {
                    name: "Number"
                }
            },
            maxQuantityToBuy: {
                serializedName: "MaxQuantityToBuy",
                type: {
                    name: "Number"
                }
            },
            maxAmountToSpend: {
                serializedName: "MaxAmountToSpend",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingOffersDto = {
    serializedName: "GlobalShoppingOffersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOffersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOfferDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersOnboardingTestDto = {
    serializedName: "GlobalCustomersOnboardingTestDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersOnboardingTestDto",
        modelProperties: {
            isTestPassed: {
                required: true,
                serializedName: "IsTestPassed",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalTestsOnlineTestDataSetDto = {
    serializedName: "GlobalTestsOnlineTestDataSetDto",
    type: {
        name: "Composite",
        className: "GlobalTestsOnlineTestDataSetDto",
        modelProperties: {
            id: {
                required: true,
                serializedName: "Id",
                type: {
                    name: "Number"
                }
            },
            name: {
                readOnly: true,
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            description: {
                readOnly: true,
                serializedName: "Description",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalTestsOnlineTestDataSetsDto = {
    serializedName: "GlobalTestsOnlineTestDataSetsDto",
    type: {
        name: "Composite",
        className: "GlobalTestsOnlineTestDataSetsDto",
        modelProperties: {
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            },
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalTestsOnlineTestDataSetDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingOrderItemDto = {
    serializedName: "GlobalShoppingOrderItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOrderItemDto",
        modelProperties: {
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            totalBp: {
                required: true,
                serializedName: "TotalBp",
                type: {
                    name: "Number"
                }
            },
            totalPrice: {
                required: true,
                serializedName: "TotalPrice",
                type: {
                    name: "Number"
                }
            },
            totalDiscount: {
                required: true,
                serializedName: "TotalDiscount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingOrderDto = {
    serializedName: "GlobalShoppingOrderDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOrderDto",
        modelProperties: {
            orderId: {
                required: true,
                serializedName: "OrderId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            deliveryAddressId: {
                serializedName: "DeliveryAddressId",
                type: {
                    name: "Number"
                }
            },
            orderDate: {
                required: true,
                serializedName: "OrderDate",
                type: {
                    name: "DateTime"
                }
            },
            fee: {
                required: true,
                serializedName: "Fee",
                type: {
                    name: "Number"
                }
            },
            totalAmount: {
                required: true,
                serializedName: "TotalAmount",
                type: {
                    name: "Number"
                }
            },
            totalDiscountAmount: {
                required: true,
                serializedName: "TotalDiscountAmount",
                type: {
                    name: "Number"
                }
            },
            prepaid: {
                required: true,
                serializedName: "Prepaid",
                type: {
                    name: "Number"
                }
            },
            totalBp: {
                required: true,
                serializedName: "TotalBp",
                type: {
                    name: "Number"
                }
            },
            redeemedPoints: {
                required: true,
                serializedName: "RedeemedPoints",
                type: {
                    name: "Number"
                }
            },
            earnedPoints: {
                required: true,
                serializedName: "EarnedPoints",
                type: {
                    name: "Number"
                }
            },
            invoiceNumber: {
                serializedName: "InvoiceNumber",
                type: {
                    name: "String"
                }
            },
            debt: {
                required: true,
                serializedName: "Debt",
                type: {
                    name: "Number"
                }
            },
            dunningFee: {
                required: true,
                serializedName: "DunningFee",
                type: {
                    name: "Number"
                }
            },
            pendingAmount: {
                required: true,
                serializedName: "PendingAmount",
                type: {
                    name: "Number"
                }
            },
            fullDebt: {
                required: true,
                serializedName: "FullDebt",
                type: {
                    name: "Number"
                }
            },
            fullDebtExceptPending: {
                required: true,
                serializedName: "FullDebtExceptPending",
                type: {
                    name: "Number"
                }
            },
            dueDate: {
                serializedName: "DueDate",
                type: {
                    name: "DateTime"
                }
            },
            itemsCollection: {
                required: true,
                serializedName: "ItemsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOrderItemDto"
                        }
                    }
                }
            },
            currentTrackingStatus: {
                required: true,
                serializedName: "CurrentTrackingStatus",
                type: {
                    name: "String"
                }
            },
            currentOrderStatus: {
                required: true,
                serializedName: "CurrentOrderStatus",
                type: {
                    name: "String"
                }
            },
            deliveryChannelId: {
                serializedName: "DeliveryChannelId",
                type: {
                    name: "Number"
                }
            },
            paymentProviderId: {
                required: true,
                serializedName: "PaymentProviderId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingUnpaidOrderDto = {
    serializedName: "GlobalShoppingUnpaidOrderDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingUnpaidOrderDto",
        modelProperties: {
            orderId: {
                required: true,
                serializedName: "OrderId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            orderDate: {
                required: true,
                serializedName: "OrderDate",
                type: {
                    name: "DateTime"
                }
            },
            invoiceNumber: {
                serializedName: "InvoiceNumber",
                type: {
                    name: "String"
                }
            },
            debt: {
                required: true,
                serializedName: "Debt",
                type: {
                    name: "Number"
                }
            },
            dunningFee: {
                serializedName: "DunningFee",
                type: {
                    name: "Number"
                }
            },
            dueDate: {
                serializedName: "DueDate",
                type: {
                    name: "DateTime"
                }
            },
            amountToPay: {
                required: true,
                serializedName: "AmountToPay",
                type: {
                    name: "Number"
                }
            },
            consultantNumber: {
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            origin: {
                required: true,
                serializedName: "Origin",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingOrderTrackingStepDto = {
    serializedName: "GlobalShoppingOrderTrackingStepDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOrderTrackingStepDto",
        modelProperties: {
            status: {
                required: true,
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            dateTime: {
                serializedName: "DateTime",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalShoppingOrderTrackingsDto = {
    serializedName: "GlobalShoppingOrderTrackingsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingOrderTrackingsDto",
        modelProperties: {
            isRealTimeOrderTrackingEnabled: {
                required: true,
                serializedName: "IsRealTimeOrderTrackingEnabled",
                type: {
                    name: "Boolean"
                }
            },
            orderId: {
                required: true,
                serializedName: "OrderId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            currentStatus: {
                serializedName: "CurrentStatus",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            waybillNumber: {
                serializedName: "WaybillNumber",
                type: {
                    name: "String"
                }
            },
            isCourierApiEnabled: {
                required: true,
                serializedName: "IsCourierApiEnabled",
                type: {
                    name: "Boolean"
                }
            },
            step1: {
                serializedName: "Step1",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOrderTrackingStepDto"
                }
            },
            step2: {
                serializedName: "Step2",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOrderTrackingStepDto"
                }
            },
            step3: {
                serializedName: "Step3",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOrderTrackingStepDto"
                }
            },
            step4: {
                serializedName: "Step4",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOrderTrackingStepDto"
                }
            },
            step5: {
                serializedName: "Step5",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingOrderTrackingStepDto"
                }
            }
        }
    }
};
export var GlobalShoppingPaymentMethodDto = {
    serializedName: "GlobalShoppingPaymentMethodDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingPaymentMethodDto",
        modelProperties: {
            paymentMethod: {
                required: true,
                serializedName: "PaymentMethod",
                type: {
                    name: "String"
                }
            },
            blockReason: {
                serializedName: "BlockReason",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingPaymentMethodsDto = {
    serializedName: "GlobalShoppingPaymentMethodsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingPaymentMethodsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingPaymentMethodDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingPaymentProviderDto = {
    serializedName: "GlobalShoppingPaymentProviderDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingPaymentProviderDto",
        modelProperties: {
            paymentProviderId: {
                required: true,
                serializedName: "PaymentProviderId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingPaymentProvidersDto = {
    serializedName: "GlobalShoppingPaymentProvidersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingPaymentProvidersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingPaymentProviderDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingPaymentDto = {
    serializedName: "GlobalShoppingPaymentDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingPaymentDto",
        modelProperties: {
            paymentProviderId: {
                required: true,
                serializedName: "PaymentProviderId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalBonusesPeriodDto = {
    serializedName: "GlobalBonusesPeriodDto",
    type: {
        name: "Composite",
        className: "GlobalBonusesPeriodDto",
        modelProperties: {
            periodId: {
                required: true,
                serializedName: "PeriodId",
                type: {
                    name: "Number"
                }
            },
            periodCode: {
                required: true,
                serializedName: "PeriodCode",
                type: {
                    name: "Number"
                }
            },
            valid: {
                serializedName: "Valid",
                type: {
                    name: "Composite",
                    className: "GlobalSharedDateTimeOffsetValidityDto"
                }
            },
            offset: {
                required: true,
                serializedName: "Offset",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalBonusesCurrentPeriodDto = {
    serializedName: "GlobalBonusesCurrentPeriodDto",
    type: {
        name: "Composite",
        className: "GlobalBonusesCurrentPeriodDto",
        modelProperties: {
            period: {
                serializedName: "Period",
                type: {
                    name: "Composite",
                    className: "GlobalBonusesPeriodDto"
                }
            },
            daysLeftInPeriod: {
                required: true,
                serializedName: "DaysLeftInPeriod",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalConceptsPermissionsQueryDto = {
    serializedName: "GlobalConceptsPermissionsQueryDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsPermissionsQueryDto",
        modelProperties: {
            conceptCodes: {
                serializedName: "ConceptCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalConceptsPermissionDto = {
    serializedName: "GlobalConceptsPermissionDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsPermissionDto",
        modelProperties: {
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            canDisplay: {
                required: true,
                serializedName: "CanDisplay",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalConceptsPermissionsDto = {
    serializedName: "GlobalConceptsPermissionsDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsPermissionsDto",
        modelProperties: {
            conceptPermissionsCollection: {
                required: true,
                serializedName: "ConceptPermissionsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalConceptsPermissionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsPermissionsQueryDto = {
    serializedName: "GlobalProductsPermissionsQueryDto",
    type: {
        name: "Composite",
        className: "GlobalProductsPermissionsQueryDto",
        modelProperties: {
            productCodes: {
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsPermissionDto = {
    serializedName: "GlobalProductsPermissionDto",
    type: {
        name: "Composite",
        className: "GlobalProductsPermissionDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            canDisplay: {
                required: true,
                serializedName: "CanDisplay",
                type: {
                    name: "Boolean"
                }
            },
            canBuy: {
                required: true,
                serializedName: "CanBuy",
                type: {
                    name: "Boolean"
                }
            },
            canSell: {
                required: true,
                serializedName: "CanSell",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalProductsPermissionsDto = {
    serializedName: "GlobalProductsPermissionsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsPermissionsDto",
        modelProperties: {
            productPermissionsCollection: {
                required: true,
                serializedName: "ProductPermissionsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsPermissionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersPermissionDto = {
    serializedName: "GlobalCustomersPermissionDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPermissionDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersPersonalBeautyStoreDto = {
    serializedName: "GlobalCustomersPersonalBeautyStoreDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPersonalBeautyStoreDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataPbsMetadataDto = {
    serializedName: "GlobalCustomersMetadataPbsMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataPbsMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationsDto"
                }
            }
        }
    }
};
export var GlobalApplicationsPersonalMenuPersonalMenuItemDto = {
    serializedName: "GlobalApplicationsPersonalMenuPersonalMenuItemDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsPersonalMenuPersonalMenuItemDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            icon: {
                serializedName: "Icon",
                type: {
                    name: "String"
                }
            },
            subItems: {
                required: true,
                serializedName: "SubItems",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsPersonalMenuPersonalMenuItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsPersonalMenuPersonalMenuDto = {
    serializedName: "GlobalApplicationsPersonalMenuPersonalMenuDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsPersonalMenuPersonalMenuDto",
        modelProperties: {
            customerFirstName: {
                serializedName: "CustomerFirstName",
                type: {
                    name: "String"
                }
            },
            customerLastName: {
                serializedName: "CustomerLastName",
                type: {
                    name: "String"
                }
            },
            userType: {
                required: true,
                serializedName: "UserType",
                type: {
                    name: "String"
                }
            },
            userHash: {
                serializedName: "UserHash",
                type: {
                    name: "String"
                }
            },
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsPersonalMenuPersonalMenuItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalKpisPersonalPerformanceDto = {
    serializedName: "GlobalKpisPersonalPerformanceDto",
    type: {
        name: "Composite",
        className: "GlobalKpisPersonalPerformanceDto",
        modelProperties: {
            personalBonusPoints: {
                required: true,
                serializedName: "PersonalBonusPoints",
                type: {
                    name: "Number"
                }
            },
            personalSales: {
                required: true,
                serializedName: "PersonalSales",
                type: {
                    name: "Number"
                }
            },
            personalStarters: {
                required: true,
                serializedName: "PersonalStarters",
                type: {
                    name: "Number"
                }
            },
            personalQualifiedRecruits: {
                required: true,
                serializedName: "PersonalQualifiedRecruits",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersPersonalProductsListItemDto = {
    serializedName: "GlobalCustomersPersonalProductsListItemDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPersonalProductsListItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersPersonalProductsListDto = {
    serializedName: "GlobalCustomersPersonalProductsListDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPersonalProductsListDto",
        modelProperties: {
            productListId: {
                required: true,
                serializedName: "ProductListId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersPersonalProductsListItemDto"
                        }
                    }
                }
            },
            created: {
                serializedName: "Created",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalCustomersPersonalProductsListsDto = {
    serializedName: "GlobalCustomersPersonalProductsListsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPersonalProductsListsDto",
        modelProperties: {
            personalProductLists: {
                required: true,
                serializedName: "PersonalProductLists",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersPersonalProductsListDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsPersonalProductsListConfigurationDto = {
    serializedName: "GlobalApplicationsPersonalProductsListConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsPersonalProductsListConfigurationDto",
        modelProperties: {
            addThis: {
                serializedName: "AddThis",
                type: {
                    name: "Composite",
                    className: "GlobalSharedAddThisDto"
                }
            },
            homePageUrl: {
                serializedName: "HomePageUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersTelephoneConnectionsDto = {
    serializedName: "GlobalCustomersTelephoneConnectionsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersTelephoneConnectionsDto",
        modelProperties: {
            whatsApp: {
                required: true,
                serializedName: "WhatsApp",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersPhoneDto = {
    serializedName: "GlobalCustomersPhoneDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPhoneDto",
        modelProperties: {
            telephoneId: {
                serializedName: "TelephoneId",
                type: {
                    name: "Number"
                }
            },
            telephoneNumber: {
                serializedName: "TelephoneNumber",
                type: {
                    name: "String"
                }
            },
            telephoneType: {
                required: true,
                serializedName: "TelephoneType",
                type: {
                    name: "String"
                }
            },
            isVerified: {
                required: true,
                serializedName: "IsVerified",
                type: {
                    name: "Boolean"
                }
            },
            isPrimary: {
                required: true,
                serializedName: "IsPrimary",
                type: {
                    name: "Boolean"
                }
            },
            connections: {
                serializedName: "Connections",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersTelephoneConnectionsDto"
                }
            }
        }
    }
};
export var GlobalCustomersPhonesDto = {
    serializedName: "GlobalCustomersPhonesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersPhonesDto",
        modelProperties: {
            telephonesCollection: {
                required: true,
                serializedName: "TelephonesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersPhoneDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersMetadataTelephoneConnectionsMetadataDto = {
    serializedName: "GlobalCustomersMetadataTelephoneConnectionsMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataTelephoneConnectionsMetadataDto",
        modelProperties: {
            whatsApp: {
                serializedName: "WhatsApp",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataBooleanPropertyDto"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataTelephoneMetadataDto = {
    serializedName: "GlobalCustomersMetadataTelephoneMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataTelephoneMetadataDto",
        modelProperties: {
            operations: {
                serializedName: "Operations",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataOperationsOperationsDto"
                }
            },
            telephoneNumber: {
                serializedName: "TelephoneNumber",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            isVerificationEnabled: {
                required: true,
                serializedName: "IsVerificationEnabled",
                type: {
                    name: "Boolean"
                }
            },
            connections: {
                serializedName: "Connections",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersMetadataTelephoneConnectionsMetadataDto"
                }
            }
        }
    }
};
export var GlobalCustomersTelephoneVerificationRequestDto = {
    serializedName: "GlobalCustomersTelephoneVerificationRequestDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersTelephoneVerificationRequestDto",
        modelProperties: {
            requestStatus: {
                required: true,
                serializedName: "RequestStatus",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalPopularProductsPopularProductDto = {
    serializedName: "GlobalPopularProductsPopularProductDto",
    type: {
        name: "Composite",
        className: "GlobalPopularProductsPopularProductDto",
        modelProperties: {
            code: {
                serializedName: "Code",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalPopularProductsProductCollectionDto = {
    serializedName: "GlobalPopularProductsProductCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalPopularProductsProductCollectionDto",
        modelProperties: {
            productCollection: {
                required: true,
                serializedName: "ProductCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalPopularProductsPopularProductDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersCustomerPreferencesDto = {
    serializedName: "GlobalCustomersCustomerPreferencesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersCustomerPreferencesDto",
        modelProperties: {
            myWhy: {
                serializedName: "MyWhy",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataCustomerPreferencesMetadataDto = {
    serializedName: "GlobalCustomersMetadataCustomerPreferencesMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataCustomerPreferencesMetadataDto",
        modelProperties: {
            myWhy: {
                serializedName: "MyWhy",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            }
        }
    }
};
export var GlobalConceptsConceptPricesQueryDto = {
    serializedName: "GlobalConceptsConceptPricesQueryDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptPricesQueryDto",
        modelProperties: {
            conceptCodes: {
                serializedName: "ConceptCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalConceptsPriceDto = {
    serializedName: "GlobalConceptsPriceDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                required: true,
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "Number"
                }
            },
            currentPrice: {
                required: true,
                serializedName: "CurrentPrice",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalConceptsConceptPriceDto = {
    serializedName: "GlobalConceptsConceptPriceDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "GlobalConceptsPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalConceptsConceptPricesDto = {
    serializedName: "GlobalConceptsConceptPricesDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConceptPricesDto",
        modelProperties: {
            conceptPricesCollection: {
                required: true,
                serializedName: "ConceptPricesCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalConceptsConceptPriceDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalConceptsConsultantConceptPriceDto = {
    serializedName: "GlobalConceptsConsultantConceptPriceDto",
    type: {
        name: "Composite",
        className: "GlobalConceptsConsultantConceptPriceDto",
        modelProperties: {
            consultantPrice: {
                serializedName: "ConsultantPrice",
                type: {
                    name: "Composite",
                    className: "GlobalConceptsPriceDto"
                }
            },
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "GlobalConceptsPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalProductsProductPricesQueryDto = {
    serializedName: "GlobalProductsProductPricesQueryDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductPricesQueryDto",
        modelProperties: {
            productCodes: {
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsPriceDto = {
    serializedName: "GlobalProductsPriceDto",
    type: {
        name: "Composite",
        className: "GlobalProductsPriceDto",
        modelProperties: {
            basicCataloguePrice: {
                required: true,
                serializedName: "BasicCataloguePrice",
                type: {
                    name: "Number"
                }
            },
            currentPrice: {
                required: true,
                serializedName: "CurrentPrice",
                type: {
                    name: "Number"
                }
            },
            basicCatalogueConsultantPrice: {
                serializedName: "BasicCatalogueConsultantPrice",
                type: {
                    name: "Number"
                }
            },
            currentConsultantPrice: {
                serializedName: "CurrentConsultantPrice",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsProductPriceDto = {
    serializedName: "GlobalProductsProductPriceDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductPriceDto",
        modelProperties: {
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "GlobalProductsPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsProductPricesDto = {
    serializedName: "GlobalProductsProductPricesDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductPricesDto",
        modelProperties: {
            productPriceCollection: {
                required: true,
                serializedName: "ProductPriceCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductPriceDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsConsultantProductPriceDto = {
    serializedName: "GlobalProductsConsultantProductPriceDto",
    type: {
        name: "Composite",
        className: "GlobalProductsConsultantProductPriceDto",
        modelProperties: {
            consultantPrice: {
                serializedName: "ConsultantPrice",
                type: {
                    name: "Composite",
                    className: "GlobalProductsPriceDto"
                }
            },
            price: {
                serializedName: "Price",
                type: {
                    name: "Composite",
                    className: "GlobalProductsPriceDto"
                }
            },
            currency: {
                serializedName: "Currency",
                type: {
                    name: "String"
                }
            },
            currencyCode: {
                serializedName: "CurrencyCode",
                type: {
                    name: "String"
                }
            },
            dateCalculated: {
                required: true,
                serializedName: "DateCalculated",
                type: {
                    name: "DateTime"
                }
            },
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsBundleComponentDto = {
    serializedName: "GlobalProductsBundleComponentDto",
    type: {
        name: "Composite",
        className: "GlobalProductsBundleComponentDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsProductBundleDto = {
    serializedName: "GlobalProductsProductBundleDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductBundleDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            bundleComponents: {
                required: true,
                serializedName: "BundleComponents",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsBundleComponentDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsProductBundlesDto = {
    serializedName: "GlobalProductsProductBundlesDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductBundlesDto",
        modelProperties: {
            productBundles: {
                required: true,
                serializedName: "ProductBundles",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductBundleDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsProductLabelContentDto = {
    serializedName: "GlobalProductsProductLabelContentDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductLabelContentDto",
        modelProperties: {
            labelKey: {
                serializedName: "LabelKey",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            helpText: {
                serializedName: "HelpText",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalProductsProductLabelsContentCollectionDto = {
    serializedName: "GlobalProductsProductLabelsContentCollectionDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductLabelsContentCollectionDto",
        modelProperties: {
            productLabelsContentCollection: {
                required: true,
                serializedName: "ProductLabelsContentCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductLabelContentDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalSharedProductListItemDto = {
    serializedName: "GlobalSharedProductListItemDto",
    type: {
        name: "Composite",
        className: "GlobalSharedProductListItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSharedProductListDto = {
    serializedName: "GlobalSharedProductListDto",
    type: {
        name: "Composite",
        className: "GlobalSharedProductListDto",
        modelProperties: {
            productListId: {
                serializedName: "ProductListId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            created: {
                readOnly: true,
                serializedName: "Created",
                type: {
                    name: "DateTime"
                }
            },
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSharedProductListItemDto"
                        }
                    }
                }
            },
            customerId: {
                readOnly: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersProductListsDto = {
    serializedName: "GlobalCustomersProductListsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersProductListsDto",
        modelProperties: {
            productLists: {
                required: true,
                serializedName: "ProductLists",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSharedProductListDto"
                        }
                    }
                }
            },
            maximumAllowedRecords: {
                required: true,
                serializedName: "MaximumAllowedRecords",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsProductListingItemDto = {
    serializedName: "GlobalProductsProductListingItemDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductListingItemDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalProductsProductListingDto = {
    serializedName: "GlobalProductsProductListingDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductListingDto",
        modelProperties: {
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            desription: {
                serializedName: "Desription",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            contentCollection: {
                required: true,
                serializedName: "ContentCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductListingItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsBannerVideoDto = {
    serializedName: "GlobalProductsBannerVideoDto",
    type: {
        name: "Composite",
        className: "GlobalProductsBannerVideoDto",
        modelProperties: {
            youtubeVideoId: {
                serializedName: "YoutubeVideoId",
                type: {
                    name: "String"
                }
            },
            youtubeVideoUser: {
                serializedName: "YoutubeVideoUser",
                type: {
                    name: "String"
                }
            },
            youtubeVideoTitle: {
                serializedName: "YoutubeVideoTitle",
                type: {
                    name: "String"
                }
            },
            thumbnail: {
                serializedName: "Thumbnail",
                type: {
                    name: "String"
                }
            },
            youkuVideoId: {
                serializedName: "YoukuVideoId",
                type: {
                    name: "String"
                }
            },
            arrowType: {
                serializedName: "ArrowType",
                type: {
                    name: "String"
                }
            },
            mP4Url: {
                serializedName: "MP4Url",
                type: {
                    name: "String"
                }
            },
            webmUrl: {
                serializedName: "WebmUrl",
                type: {
                    name: "String"
                }
            },
            autoplayOnScroll: {
                required: true,
                serializedName: "AutoplayOnScroll",
                type: {
                    name: "Boolean"
                }
            },
            loop: {
                required: true,
                serializedName: "Loop",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalProductsBannerDto = {
    serializedName: "GlobalProductsBannerDto",
    type: {
        name: "Composite",
        className: "GlobalProductsBannerDto",
        modelProperties: {
            headline: {
                serializedName: "Headline",
                type: {
                    name: "String"
                }
            },
            textColour: {
                serializedName: "TextColour",
                type: {
                    name: "String"
                }
            },
            size: {
                serializedName: "Size",
                type: {
                    name: "Number"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            imageHoverUrl: {
                serializedName: "ImageHoverUrl",
                type: {
                    name: "String"
                }
            },
            link: {
                serializedName: "Link",
                type: {
                    name: "String"
                }
            },
            linkTitle: {
                serializedName: "LinkTitle",
                type: {
                    name: "String"
                }
            },
            contentVerticalAlignment: {
                serializedName: "ContentVerticalAlignment",
                type: {
                    name: "String"
                }
            },
            isUpperCase: {
                required: true,
                serializedName: "IsUpperCase",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalProductsBannerProductDto = {
    serializedName: "GlobalProductsBannerProductDto",
    type: {
        name: "Composite",
        className: "GlobalProductsBannerProductDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            pricePosX: {
                serializedName: "PricePosX",
                type: {
                    name: "Number"
                }
            },
            pricePosY: {
                serializedName: "PricePosY",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalProductsProductListingPromoBannerDto = {
    serializedName: "GlobalProductsProductListingPromoBannerDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductListingPromoBannerDto",
        modelProperties: {
            promoBannerId: {
                serializedName: "PromoBannerId",
                type: {
                    name: "String"
                }
            },
            video: {
                serializedName: "Video",
                type: {
                    name: "Composite",
                    className: "GlobalProductsBannerVideoDto"
                }
            },
            banner: {
                serializedName: "Banner",
                type: {
                    name: "Composite",
                    className: "GlobalProductsBannerDto"
                }
            },
            product: {
                serializedName: "Product",
                type: {
                    name: "Composite",
                    className: "GlobalProductsBannerProductDto"
                }
            }
        }
    }
};
export var GlobalProductsProductListingPromoBannersDto = {
    serializedName: "GlobalProductsProductListingPromoBannersDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductListingPromoBannersDto",
        modelProperties: {
            productListingPromoBannersCollection: {
                required: true,
                serializedName: "ProductListingPromoBannersCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductListingPromoBannerDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsQueryDto = {
    serializedName: "GlobalProductsQueryDto",
    type: {
        name: "Composite",
        className: "GlobalProductsQueryDto",
        modelProperties: {
            productCodes: {
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            paging: {
                serializedName: "Paging",
                type: {
                    name: "Composite",
                    className: "GlobalSharedPagingDto"
                }
            }
        }
    }
};
export var GlobalProductsTagDto = {
    serializedName: "GlobalProductsTagDto",
    type: {
        name: "Composite",
        className: "GlobalProductsTagDto",
        modelProperties: {
            value: {
                serializedName: "Value",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalProductsTagGroupDto = {
    serializedName: "GlobalProductsTagGroupDto",
    type: {
        name: "Composite",
        className: "GlobalProductsTagGroupDto",
        modelProperties: {
            groupName: {
                serializedName: "GroupName",
                type: {
                    name: "String"
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsTagDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsProductDto = {
    serializedName: "GlobalProductsProductDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductDto",
        modelProperties: {
            productCode: {
                serializedName: "ProductCode",
                type: {
                    name: "String"
                }
            },
            productType: {
                required: true,
                serializedName: "ProductType",
                type: {
                    name: "String"
                }
            },
            conceptCode: {
                serializedName: "ConceptCode",
                type: {
                    name: "String"
                }
            },
            color: {
                serializedName: "Color",
                type: {
                    name: "String"
                }
            },
            colorHexCode: {
                serializedName: "ColorHexCode",
                type: {
                    name: "String"
                }
            },
            colorImageUrl: {
                serializedName: "ColorImageUrl",
                type: {
                    name: "String"
                }
            },
            volume: {
                serializedName: "Volume",
                type: {
                    name: "Number"
                }
            },
            volumeUnit: {
                serializedName: "VolumeUnit",
                type: {
                    name: "String"
                }
            },
            thumbnailUrl: {
                serializedName: "ThumbnailUrl",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            alternativeImageUrls: {
                required: true,
                serializedName: "AlternativeImageUrls",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsTagGroupDto"
                        }
                    }
                }
            },
            hashCode: {
                required: true,
                serializedName: "HashCode",
                type: {
                    name: "Number"
                }
            },
            isDiscontinued: {
                required: true,
                serializedName: "IsDiscontinued",
                type: {
                    name: "Boolean"
                }
            },
            isSample: {
                required: true,
                serializedName: "IsSample",
                type: {
                    name: "Boolean"
                }
            },
            isOutlet: {
                required: true,
                serializedName: "IsOutlet",
                type: {
                    name: "Boolean"
                }
            },
            introDate: {
                serializedName: "IntroDate",
                type: {
                    name: "DateTime"
                }
            },
            discoDate: {
                serializedName: "DiscoDate",
                type: {
                    name: "DateTime"
                }
            },
            showOnSite: {
                required: true,
                serializedName: "ShowOnSite",
                type: {
                    name: "Boolean"
                }
            },
            videoUrl: {
                serializedName: "VideoUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalProductsProductsDto = {
    serializedName: "GlobalProductsProductsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsProductsDto",
        modelProperties: {
            productsCollection: {
                required: true,
                serializedName: "ProductsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsProductDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersCustomerTypeDto = {
    serializedName: "GlobalCustomersCustomerTypeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersCustomerTypeDto",
        modelProperties: {
            customerCategory: {
                required: true,
                serializedName: "CustomerCategory",
                type: {
                    name: "String"
                }
            },
            customerTypeId: {
                required: true,
                serializedName: "CustomerTypeId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            isVipCustomer: {
                required: true,
                serializedName: "IsVipCustomer",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersProfileDto = {
    serializedName: "GlobalCustomersProfileDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersProfileDto",
        modelProperties: {
            consultantNumber: {
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            customerType: {
                serializedName: "CustomerType",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersCustomerTypeDto"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            sponsorNumber: {
                serializedName: "SponsorNumber",
                type: {
                    name: "Number"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "String"
                }
            },
            displayName: {
                serializedName: "DisplayName",
                type: {
                    name: "String"
                }
            },
            alias: {
                serializedName: "Alias",
                type: {
                    name: "String"
                }
            },
            taxCode: {
                serializedName: "TaxCode",
                type: {
                    name: "String"
                }
            },
            taxCode2: {
                serializedName: "TaxCode2",
                type: {
                    name: "String"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "DateTime"
                }
            },
            passportNumber: {
                serializedName: "PassportNumber",
                type: {
                    name: "String"
                }
            },
            preferredLanguage: {
                serializedName: "PreferredLanguage",
                type: {
                    name: "String"
                }
            },
            pin: {
                serializedName: "Pin",
                type: {
                    name: "String"
                }
            },
            sponsorName: {
                serializedName: "SponsorName",
                type: {
                    name: "String"
                }
            },
            careerTitle: {
                serializedName: "CareerTitle",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersMetadataProfileMetadataDto = {
    serializedName: "GlobalCustomersMetadataProfileMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersMetadataProfileMetadataDto",
        modelProperties: {
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataEnumPropertyDto"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataDateTimePropertyDto"
                }
            },
            preferredLanguage: {
                serializedName: "PreferredLanguage",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            displayName: {
                serializedName: "DisplayName",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            alias: {
                serializedName: "Alias",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            taxCode: {
                serializedName: "TaxCode",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            taxCode2: {
                serializedName: "TaxCode2",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            passportNumber: {
                serializedName: "PassportNumber",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            },
            pin: {
                serializedName: "Pin",
                type: {
                    name: "Composite",
                    className: "GlobalSharedMetadataStringPropertyDto"
                }
            }
        }
    }
};
export var GlobalApplicationsProfileSectionConfigurationDto = {
    serializedName: "GlobalApplicationsProfileSectionConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsProfileSectionConfigurationDto",
        modelProperties: {
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalApplicationsProfileSharedConfigurationDto = {
    serializedName: "GlobalApplicationsProfileSharedConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsProfileSharedConfigurationDto",
        modelProperties: {
            useUpperCase: {
                required: true,
                serializedName: "UseUpperCase",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalApplicationsProfileSectionsConfigurationDto = {
    serializedName: "GlobalApplicationsProfileSectionsConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsProfileSectionsConfigurationDto",
        modelProperties: {
            customerSelect: {
                serializedName: "CustomerSelect",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsProfileSectionConfigurationDto"
                }
            },
            externalProfiles: {
                serializedName: "ExternalProfiles",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsProfileSectionConfigurationDto"
                }
            },
            emails: {
                serializedName: "Emails",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsProfileSectionConfigurationDto"
                }
            },
            telephones: {
                serializedName: "Telephones",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsProfileSectionConfigurationDto"
                }
            },
            bankAccounts: {
                serializedName: "BankAccounts",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsProfileSectionConfigurationDto"
                }
            },
            shared: {
                serializedName: "Shared",
                type: {
                    name: "Composite",
                    className: "GlobalApplicationsProfileSharedConfigurationDto"
                }
            }
        }
    }
};
export var GlobalApplicationsProfileExternalProfilesMetadataDto = {
    serializedName: "GlobalApplicationsProfileExternalProfilesMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsProfileExternalProfilesMetadataDto",
        modelProperties: {
            availableOptions: {
                required: true,
                serializedName: "AvailableOptions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalPromotionsPromotionDto = {
    serializedName: "GlobalPromotionsPromotionDto",
    type: {
        name: "Composite",
        className: "GlobalPromotionsPromotionDto",
        modelProperties: {
            promotionId: {
                required: true,
                serializedName: "PromotionId",
                type: {
                    name: "Number"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageUrl: {
                serializedName: "ImageUrl",
                type: {
                    name: "String"
                }
            },
            discount: {
                serializedName: "Discount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalPromotionsPromotionsDto = {
    serializedName: "GlobalPromotionsPromotionsDto",
    type: {
        name: "Composite",
        className: "GlobalPromotionsPromotionsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalPromotionsPromotionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalNotificationsInstallationRequestDto = {
    serializedName: "GlobalNotificationsInstallationRequestDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsInstallationRequestDto",
        modelProperties: {
            pnsHandle: {
                required: true,
                serializedName: "PnsHandle",
                type: {
                    name: "String"
                }
            },
            platform: {
                required: true,
                serializedName: "Platform",
                type: {
                    name: "String"
                }
            },
            platformUserId: {
                serializedName: "PlatformUserId",
                type: {
                    name: "String"
                }
            },
            expiration: {
                serializedName: "Expiration",
                type: {
                    name: "DateTime"
                }
            }
        }
    }
};
export var GlobalNotificationsPushRegistrationDto = {
    serializedName: "GlobalNotificationsPushRegistrationDto",
    type: {
        name: "Composite",
        className: "GlobalNotificationsPushRegistrationDto",
        modelProperties: {
            registrationId: {
                serializedName: "RegistrationId",
                type: {
                    name: "String"
                }
            },
            applicationKey: {
                serializedName: "ApplicationKey",
                type: {
                    name: "String"
                }
            },
            platform: {
                required: true,
                serializedName: "Platform",
                type: {
                    name: "String"
                }
            },
            deviceToken: {
                serializedName: "DeviceToken",
                type: {
                    name: "String"
                }
            },
            platformSpecificId: {
                serializedName: "PlatformSpecificId",
                type: {
                    name: "String"
                }
            },
            locale: {
                serializedName: "Locale",
                type: {
                    name: "String"
                }
            },
            consultantId: {
                serializedName: "ConsultantId",
                type: {
                    name: "String"
                }
            },
            expiration: {
                serializedName: "Expiration",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersRecurringPaymentCardDto = {
    serializedName: "GlobalCustomersRecurringPaymentCardDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRecurringPaymentCardDto",
        modelProperties: {
            recurringPaymentCardId: {
                required: true,
                serializedName: "RecurringPaymentCardId",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            cardNumberLast4: {
                serializedName: "CardNumberLast4",
                type: {
                    name: "String"
                }
            },
            expiryMonth: {
                serializedName: "ExpiryMonth",
                type: {
                    name: "Number"
                }
            },
            expiryYear: {
                serializedName: "ExpiryYear",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersRecurringPaymentCardsDto = {
    serializedName: "GlobalCustomersRecurringPaymentCardsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRecurringPaymentCardsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersRecurringPaymentCardDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingReferralDto = {
    serializedName: "GlobalShoppingReferralDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingReferralDto",
        modelProperties: {
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            referralType: {
                required: true,
                serializedName: "ReferralType",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersConsultantRegistrationDto = {
    serializedName: "GlobalCustomersConsultantRegistrationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersConsultantRegistrationDto",
        modelProperties: {
            registrationType: {
                required: true,
                serializedName: "RegistrationType",
                type: {
                    name: "String"
                }
            },
            activationType: {
                serializedName: "ActivationType",
                type: {
                    name: "String"
                }
            },
            consultantType: {
                serializedName: "ConsultantType",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "String"
                }
            },
            taxCode: {
                serializedName: "TaxCode",
                type: {
                    name: "String"
                }
            },
            taxCode2: {
                serializedName: "TaxCode2",
                type: {
                    name: "String"
                }
            },
            passport: {
                serializedName: "Passport",
                type: {
                    name: "String"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "DateTime"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "String"
                }
            },
            confirmation1: {
                required: true,
                serializedName: "Confirmation1",
                type: {
                    name: "Boolean"
                }
            },
            confirmation2: {
                required: true,
                serializedName: "Confirmation2",
                type: {
                    name: "Boolean"
                }
            },
            preferredLanguage: {
                serializedName: "PreferredLanguage",
                type: {
                    name: "String"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "GlobalSharedAddressDto"
                }
            },
            approvals: {
                serializedName: "Approvals",
                type: {
                    name: "Composite",
                    className: "GlobalSharedApprovalDto"
                }
            },
            attributes: {
                serializedName: "Attributes",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersAttributesDto"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersRegistrationResultDto = {
    serializedName: "GlobalCustomersRegistrationResultDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRegistrationResultDto",
        modelProperties: {
            consultantNumber: {
                required: true,
                serializedName: "ConsultantNumber",
                type: {
                    name: "Number"
                }
            },
            customerId: {
                required: true,
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            sponsorName: {
                serializedName: "SponsorName",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersSelfRegistrationDto = {
    serializedName: "GlobalCustomersSelfRegistrationDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSelfRegistrationDto",
        modelProperties: {
            sponsorNumber: {
                serializedName: "SponsorNumber",
                type: {
                    name: "Number"
                }
            },
            password: {
                serializedName: "Password",
                type: {
                    name: "String"
                }
            },
            activationType: {
                serializedName: "ActivationType",
                type: {
                    name: "String"
                }
            },
            consultantType: {
                serializedName: "ConsultantType",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            uniqueId: {
                serializedName: "UniqueId",
                type: {
                    name: "String"
                }
            },
            taxCode: {
                serializedName: "TaxCode",
                type: {
                    name: "String"
                }
            },
            taxCode2: {
                serializedName: "TaxCode2",
                type: {
                    name: "String"
                }
            },
            passport: {
                serializedName: "Passport",
                type: {
                    name: "String"
                }
            },
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            birthDate: {
                serializedName: "BirthDate",
                type: {
                    name: "DateTime"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "String"
                }
            },
            confirmation1: {
                required: true,
                serializedName: "Confirmation1",
                type: {
                    name: "Boolean"
                }
            },
            confirmation2: {
                required: true,
                serializedName: "Confirmation2",
                type: {
                    name: "Boolean"
                }
            },
            preferredLanguage: {
                serializedName: "PreferredLanguage",
                type: {
                    name: "String"
                }
            },
            address: {
                serializedName: "Address",
                type: {
                    name: "Composite",
                    className: "GlobalSharedAddressDto"
                }
            },
            approvals: {
                serializedName: "Approvals",
                type: {
                    name: "Composite",
                    className: "GlobalSharedApprovalDto"
                }
            },
            attributes: {
                serializedName: "Attributes",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersAttributesDto"
                }
            },
            gender: {
                serializedName: "Gender",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersRegistrationFieldMetadataDto = {
    serializedName: "GlobalCustomersRegistrationFieldMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRegistrationFieldMetadataDto",
        modelProperties: {
            fieldName: {
                serializedName: "FieldName",
                type: {
                    name: "String"
                }
            },
            fieldStatus: {
                required: true,
                serializedName: "FieldStatus",
                type: {
                    name: "String"
                }
            },
            fieldsMetadataCollection: {
                required: true,
                serializedName: "FieldsMetadataCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersRegistrationFieldMetadataDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersAttributeValueMetadataDto = {
    serializedName: "GlobalCustomersAttributeValueMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAttributeValueMetadataDto",
        modelProperties: {
            valueId: {
                required: true,
                serializedName: "ValueId",
                type: {
                    name: "Number"
                }
            },
            value: {
                serializedName: "Value",
                type: {
                    name: "String"
                }
            },
            isDefault: {
                required: true,
                serializedName: "IsDefault",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersAttributeMetadataDto = {
    serializedName: "GlobalCustomersAttributeMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersAttributeMetadataDto",
        modelProperties: {
            customerAttributeTypeId: {
                required: true,
                serializedName: "CustomerAttributeTypeId",
                type: {
                    name: "Number"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            status: {
                required: true,
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            dataType: {
                required: true,
                serializedName: "DataType",
                type: {
                    name: "String"
                }
            },
            valuesMetadata: {
                required: true,
                serializedName: "ValuesMetadata",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAttributeValueMetadataDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersRegistrationMetadataDto = {
    serializedName: "GlobalCustomersRegistrationMetadataDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRegistrationMetadataDto",
        modelProperties: {
            fieldsMetadataCollection: {
                required: true,
                serializedName: "FieldsMetadataCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersRegistrationFieldMetadataDto"
                        }
                    }
                }
            },
            customerAttributesMetadataCollection: {
                required: true,
                serializedName: "CustomerAttributesMetadataCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersAttributeMetadataDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsRelation = {
    serializedName: "GlobalProductsRelation",
    type: {
        name: "Composite",
        className: "GlobalProductsRelation",
        modelProperties: {
            relationType: {
                required: true,
                serializedName: "RelationType",
                type: {
                    name: "String"
                }
            },
            productCodes: {
                required: true,
                serializedName: "ProductCodes",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalProductsRelationsDto = {
    serializedName: "GlobalProductsRelationsDto",
    type: {
        name: "Composite",
        className: "GlobalProductsRelationsDto",
        modelProperties: {
            relations: {
                required: true,
                serializedName: "Relations",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalProductsRelation"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersRequiredTermDto = {
    serializedName: "GlobalCustomersRequiredTermDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRequiredTermDto",
        modelProperties: {
            termId: {
                serializedName: "TermId",
                type: {
                    name: "String"
                }
            },
            version: {
                serializedName: "Version",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            isAccepted: {
                required: true,
                serializedName: "IsAccepted",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalCustomersRequiredTermsDto = {
    serializedName: "GlobalCustomersRequiredTermsDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersRequiredTermsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersRequiredTermDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSectionItemDto = {
    serializedName: "GlobalShoppingSectionItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            isValid: {
                required: true,
                serializedName: "IsValid",
                type: {
                    name: "Boolean"
                }
            },
            invalidationReason: {
                serializedName: "InvalidationReason",
                type: {
                    name: "String"
                }
            },
            bagItemId: {
                serializedName: "BagItemId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSectionItemsDto = {
    serializedName: "GlobalShoppingSectionItemsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionItemsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSectionItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSectionDto = {
    serializedName: "GlobalShoppingSectionDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionDto",
        modelProperties: {
            sectionId: {
                required: true,
                serializedName: "SectionId",
                type: {
                    name: "Number"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            priority: {
                required: true,
                serializedName: "Priority",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSectionsDto = {
    serializedName: "GlobalShoppingSectionsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSectionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSectionSuggestionDto = {
    serializedName: "GlobalShoppingSectionSuggestionDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionSuggestionDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingSectionSuggestionsDto = {
    serializedName: "GlobalShoppingSectionSuggestionsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionSuggestionsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSectionSuggestionDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSectionWishlistItemDto = {
    serializedName: "GlobalShoppingSectionWishlistItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionWishlistItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSectionWishlistDto = {
    serializedName: "GlobalShoppingSectionWishlistDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSectionWishlistDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSectionWishlistItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalNetworkCommunicationConfigurationDto = {
    serializedName: "GlobalNetworkCommunicationConfigurationDto",
    type: {
        name: "Composite",
        className: "GlobalNetworkCommunicationConfigurationDto",
        modelProperties: {
            providers: {
                required: true,
                serializedName: "Providers",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingShippingChoiceDto = {
    serializedName: "GlobalShoppingShippingChoiceDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShippingChoiceDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingShippingChoicesDto = {
    serializedName: "GlobalShoppingShippingChoicesDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShippingChoicesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingShippingChoiceDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingShippingJokerDto = {
    serializedName: "GlobalShoppingShippingJokerDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShippingJokerDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            quantityLimit: {
                serializedName: "QuantityLimit",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingShippingJokersDto = {
    serializedName: "GlobalShoppingShippingJokersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShippingJokersDto",
        modelProperties: {
            isQuantitySelectable: {
                required: true,
                serializedName: "IsQuantitySelectable",
                type: {
                    name: "Boolean"
                }
            },
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingShippingJokerDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingDiscountDto = {
    serializedName: "GlobalShoppingDiscountDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingDiscountDto",
        modelProperties: {
            amount: {
                required: true,
                serializedName: "Amount",
                type: {
                    name: "Number"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingReplacementDto = {
    serializedName: "GlobalShoppingReplacementDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingReplacementDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingShoppingBagAggregatedItemDto = {
    serializedName: "GlobalShoppingShoppingBagAggregatedItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingBagAggregatedItemDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            bagItemId: {
                required: true,
                serializedName: "BagItemId",
                type: {
                    name: "Number"
                }
            },
            canDelete: {
                required: true,
                serializedName: "CanDelete",
                type: {
                    name: "Boolean"
                }
            },
            canModify: {
                required: true,
                serializedName: "CanModify",
                type: {
                    name: "Boolean"
                }
            },
            canReduce: {
                required: true,
                serializedName: "CanReduce",
                type: {
                    name: "Boolean"
                }
            },
            discounts: {
                required: true,
                serializedName: "Discounts",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingDiscountDto"
                        }
                    }
                }
            },
            earnedPoints: {
                required: true,
                serializedName: "EarnedPoints",
                type: {
                    name: "Number"
                }
            },
            redeemedPoints: {
                required: true,
                serializedName: "RedeemedPoints",
                type: {
                    name: "Number"
                }
            },
            points: {
                required: true,
                serializedName: "Points",
                type: {
                    name: "Number"
                }
            },
            itemType: {
                required: true,
                serializedName: "ItemType",
                type: {
                    name: "String"
                }
            },
            productFlag: {
                required: true,
                serializedName: "ProductFlag",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            requestedQuantity: {
                required: true,
                serializedName: "RequestedQuantity",
                type: {
                    name: "Number"
                }
            },
            maxQuantity: {
                required: true,
                serializedName: "MaxQuantity",
                type: {
                    name: "Number"
                }
            },
            replacements: {
                required: true,
                serializedName: "Replacements",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingReplacementDto"
                        }
                    }
                }
            },
            totalBp: {
                required: true,
                serializedName: "TotalBp",
                type: {
                    name: "Number"
                }
            },
            totalPrice: {
                required: true,
                serializedName: "TotalPrice",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingShoppingBagAggregatedItemsDto = {
    serializedName: "GlobalShoppingShoppingBagAggregatedItemsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingBagAggregatedItemsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingShoppingBagAggregatedItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingShoppingBagItemDto = {
    serializedName: "GlobalShoppingShoppingBagItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingBagItemDto",
        modelProperties: {
            bagItemId: {
                serializedName: "BagItemId",
                type: {
                    name: "Number"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            quantity: {
                required: true,
                serializedName: "Quantity",
                type: {
                    name: "Number"
                }
            },
            originalItemCode: {
                serializedName: "OriginalItemCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingShoppingMessageDto = {
    serializedName: "GlobalShoppingShoppingMessageDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingMessageDto",
        modelProperties: {
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            },
            text: {
                serializedName: "Text",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingShoppingMessagesDto = {
    serializedName: "GlobalShoppingShoppingMessagesDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingMessagesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingShoppingMessageDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingShoppingDto = {
    serializedName: "GlobalShoppingShoppingDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingDto",
        modelProperties: {
            customerId: {
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            origin: {
                serializedName: "Origin",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingShoppingSessionDto = {
    serializedName: "GlobalShoppingShoppingSessionDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingSessionDto",
        modelProperties: {
            sessionId: {
                serializedName: "SessionId",
                type: {
                    name: "String"
                }
            },
            isAnonymous: {
                required: true,
                serializedName: "IsAnonymous",
                type: {
                    name: "Boolean"
                }
            },
            isShoppingBlocked: {
                required: true,
                serializedName: "IsShoppingBlocked",
                type: {
                    name: "Boolean"
                }
            },
            isVip: {
                required: true,
                serializedName: "IsVip",
                type: {
                    name: "Boolean"
                }
            },
            customerId: {
                serializedName: "CustomerId",
                type: {
                    name: "Number"
                }
            },
            origin: {
                serializedName: "Origin",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibrarySocialEntityDto = {
    serializedName: "GlobalSocialMediaLibrarySocialEntityDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibrarySocialEntityDto",
        modelProperties: {
            socialEntityId: {
                serializedName: "SocialEntityId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibrarySocialEntitiesDto = {
    serializedName: "GlobalSocialMediaLibrarySocialEntitiesDto",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibrarySocialEntitiesDto",
        modelProperties: {
            socialEntities: {
                required: true,
                serializedName: "SocialEntities",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSocialMediaLibrarySocialEntityDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalSocialMediaLibrarySocialStatsEntity = {
    serializedName: "GlobalSocialMediaLibrarySocialStatsEntity",
    type: {
        name: "Composite",
        className: "GlobalSocialMediaLibrarySocialStatsEntity",
        modelProperties: {
            socialEntitiesStats: {
                required: true,
                serializedName: "SocialEntitiesStats",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalSocialMediaLibrarySocialEntityDto"
                        }
                    }
                }
            },
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferDto = {
    serializedName: "GlobalShoppingSpecialOfferDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferDto",
        modelProperties: {
            offerId: {
                required: true,
                serializedName: "OfferId",
                type: {
                    name: "Number"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            cataloguePrice: {
                required: true,
                serializedName: "CataloguePrice",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            },
            isAvailable: {
                required: true,
                serializedName: "IsAvailable",
                type: {
                    name: "Boolean"
                }
            },
            isBackorderAvailable: {
                required: true,
                serializedName: "IsBackorderAvailable",
                type: {
                    name: "Boolean"
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferChoiceDto = {
    serializedName: "GlobalShoppingSpecialOfferChoiceDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferChoiceDto",
        modelProperties: {
            isMainItemSelected: {
                required: true,
                serializedName: "IsMainItemSelected",
                type: {
                    name: "Boolean"
                }
            },
            isBackorderSelected: {
                required: true,
                serializedName: "IsBackorderSelected",
                type: {
                    name: "Boolean"
                }
            },
            isVoucherSelected: {
                required: true,
                serializedName: "IsVoucherSelected",
                type: {
                    name: "Boolean"
                }
            },
            selectedReplacementItemCode: {
                serializedName: "SelectedReplacementItemCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferReplacementDto = {
    serializedName: "GlobalShoppingSpecialOfferReplacementDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferReplacementDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            cataloguePrice: {
                required: true,
                serializedName: "CataloguePrice",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferReplacementsDto = {
    serializedName: "GlobalShoppingSpecialOfferReplacementsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferReplacementsDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSpecialOfferReplacementDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOffersDto = {
    serializedName: "GlobalShoppingSpecialOffersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOffersDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSpecialOfferDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferVoucherItemDto = {
    serializedName: "GlobalShoppingSpecialOfferVoucherItemDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferVoucherItemDto",
        modelProperties: {
            id: {
                required: true,
                serializedName: "Id",
                type: {
                    name: "Number"
                }
            },
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            },
            price: {
                required: true,
                serializedName: "Price",
                type: {
                    name: "Number"
                }
            },
            cataloguePrice: {
                required: true,
                serializedName: "CataloguePrice",
                type: {
                    name: "Number"
                }
            },
            bp: {
                required: true,
                serializedName: "Bp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferVoucherDto = {
    serializedName: "GlobalShoppingSpecialOfferVoucherDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferVoucherDto",
        modelProperties: {
            voucherAmount: {
                required: true,
                serializedName: "VoucherAmount",
                type: {
                    name: "Number"
                }
            },
            remainingVoucherAmount: {
                required: true,
                serializedName: "RemainingVoucherAmount",
                type: {
                    name: "Number"
                }
            },
            voucherItems: {
                required: true,
                serializedName: "VoucherItems",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingSpecialOfferVoucherItemDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingSpecialOfferVoucherChoiceDto = {
    serializedName: "GlobalShoppingSpecialOfferVoucherChoiceDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSpecialOfferVoucherChoiceDto",
        modelProperties: {
            itemCode: {
                serializedName: "ItemCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDto = {
    serializedName: "GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDto",
    type: {
        name: "Composite",
        className: "GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDto",
        modelProperties: {
            taskId: {
                serializedName: "TaskId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            detail: {
                serializedName: "Detail",
                type: {
                    name: "String"
                }
            },
            url: {
                serializedName: "Url",
                type: {
                    name: "String"
                }
            },
            taskStatus: {
                required: true,
                serializedName: "TaskStatus",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalMobileOfficeStepsToSuccessStepsToSuccessTasksDto = {
    serializedName: "GlobalMobileOfficeStepsToSuccessStepsToSuccessTasksDto",
    type: {
        name: "Composite",
        className: "GlobalMobileOfficeStepsToSuccessStepsToSuccessTasksDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDto"
                        }
                    }
                }
            },
            totalCount: {
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionPackageDto = {
    serializedName: "GlobalCustomersSubscriptionPackageDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionPackageDto",
        modelProperties: {
            packageId: {
                required: true,
                serializedName: "PackageId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            imageSrc: {
                serializedName: "ImageSrc",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionTypeDto = {
    serializedName: "GlobalCustomersSubscriptionTypeDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionTypeDto",
        modelProperties: {
            typeId: {
                required: true,
                serializedName: "TypeId",
                type: {
                    name: "Number"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            category: {
                required: true,
                serializedName: "Category",
                type: {
                    name: "String"
                }
            },
            packages: {
                required: true,
                serializedName: "Packages",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersSubscriptionPackageDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionTypesDto = {
    serializedName: "GlobalCustomersSubscriptionTypesDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionTypesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersSubscriptionTypeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionConsumerDto = {
    serializedName: "GlobalCustomersSubscriptionConsumerDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionConsumerDto",
        modelProperties: {
            firstName: {
                serializedName: "FirstName",
                type: {
                    name: "String"
                }
            },
            lastName: {
                serializedName: "LastName",
                type: {
                    name: "String"
                }
            },
            email: {
                serializedName: "Email",
                type: {
                    name: "String"
                }
            },
            telephone: {
                serializedName: "Telephone",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalCustomersSubscriptionInstructionDto = {
    serializedName: "GlobalCustomersSubscriptionInstructionDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersSubscriptionInstructionDto",
        modelProperties: {
            newConsumer: {
                serializedName: "NewConsumer",
                type: {
                    name: "Composite",
                    className: "GlobalCustomersSubscriptionConsumerDto"
                }
            },
            existingConsumerId: {
                serializedName: "ExistingConsumerId",
                type: {
                    name: "Number"
                }
            },
            packageId: {
                serializedName: "PackageId",
                type: {
                    name: "Number"
                }
            },
            status: {
                required: true,
                serializedName: "Status",
                type: {
                    name: "String"
                }
            },
            newSubscriptionId: {
                serializedName: "NewSubscriptionId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingShoppingSummaryDto = {
    serializedName: "GlobalShoppingShoppingSummaryDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingShoppingSummaryDto",
        modelProperties: {
            totalPrice: {
                required: true,
                serializedName: "TotalPrice",
                type: {
                    name: "Number"
                }
            },
            deliveryFee: {
                required: true,
                serializedName: "DeliveryFee",
                type: {
                    name: "Number"
                }
            },
            paymentFee: {
                required: true,
                serializedName: "PaymentFee",
                type: {
                    name: "Number"
                }
            },
            personalDiscount: {
                required: true,
                serializedName: "PersonalDiscount",
                type: {
                    name: "Number"
                }
            },
            prepaid: {
                required: true,
                serializedName: "Prepaid",
                type: {
                    name: "Number"
                }
            },
            debt: {
                required: true,
                serializedName: "Debt",
                type: {
                    name: "Number"
                }
            },
            earnedPoints: {
                required: true,
                serializedName: "EarnedPoints",
                type: {
                    name: "Number"
                }
            },
            redeemedPoints: {
                required: true,
                serializedName: "RedeemedPoints",
                type: {
                    name: "Number"
                }
            },
            pointsEarned: {
                required: true,
                serializedName: "PointsEarned",
                type: {
                    name: "Number"
                }
            },
            pointsUsed: {
                required: true,
                serializedName: "PointsUsed",
                type: {
                    name: "Number"
                }
            },
            totalBp: {
                required: true,
                serializedName: "TotalBp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSummaryAccountBalanceDto = {
    serializedName: "GlobalShoppingSummaryAccountBalanceDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSummaryAccountBalanceDto",
        modelProperties: {
            personalCredit: {
                serializedName: "PersonalCredit",
                type: {
                    name: "Number"
                }
            },
            grantedCredit: {
                serializedName: "GrantedCredit",
                type: {
                    name: "Number"
                }
            },
            prepayment: {
                required: true,
                serializedName: "Prepayment",
                type: {
                    name: "Number"
                }
            },
            discount: {
                serializedName: "Discount",
                type: {
                    name: "Number"
                }
            },
            loyaltyPoints: {
                serializedName: "LoyaltyPoints",
                type: {
                    name: "Number"
                }
            },
            personalBp: {
                required: true,
                serializedName: "PersonalBp",
                type: {
                    name: "Number"
                }
            },
            groupBp: {
                serializedName: "GroupBp",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalShoppingSummaryAccountsDto = {
    serializedName: "GlobalShoppingSummaryAccountsDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingSummaryAccountsDto",
        modelProperties: {
            before: {
                serializedName: "Before",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingSummaryAccountBalanceDto"
                }
            },
            after: {
                serializedName: "After",
                type: {
                    name: "Composite",
                    className: "GlobalShoppingSummaryAccountBalanceDto"
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterCategoryInfoDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterCategoryInfoDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterCategoryInfoDto",
        modelProperties: {
            categoryId: {
                serializedName: "CategoryId",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            icon: {
                serializedName: "Icon",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterCategoriesDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterCategoriesDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterCategoriesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsSupportCenterSupportCenterCategoryInfoDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterFaqDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterFaqDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterFaqDto",
        modelProperties: {
            question: {
                serializedName: "Question",
                type: {
                    name: "String"
                }
            },
            answerUrl: {
                serializedName: "AnswerUrl",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterSubCategoryDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterSubCategoryDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterSubCategoryDto",
        modelProperties: {
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            questions: {
                required: true,
                serializedName: "Questions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsSupportCenterSupportCenterFaqDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterCategoryDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterCategoryDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterCategoryDto",
        modelProperties: {
            subcategories: {
                required: true,
                serializedName: "Subcategories",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsSupportCenterSupportCenterSubCategoryDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterFeaturedFaqsDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterFeaturedFaqsDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterFeaturedFaqsDto",
        modelProperties: {
            questions: {
                required: true,
                serializedName: "Questions",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsSupportCenterSupportCenterFaqDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalApplicationsSupportCenterSupportCenterSearchResultDto = {
    serializedName: "GlobalApplicationsSupportCenterSupportCenterSearchResultDto",
    type: {
        name: "Composite",
        className: "GlobalApplicationsSupportCenterSupportCenterSearchResultDto",
        modelProperties: {
            totalCount: {
                required: true,
                serializedName: "TotalCount",
                type: {
                    name: "Number"
                }
            },
            results: {
                required: true,
                serializedName: "Results",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalApplicationsSupportCenterSupportCenterFaqDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalTagsTagDto = {
    serializedName: "GlobalTagsTagDto",
    type: {
        name: "Composite",
        className: "GlobalTagsTagDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            translation: {
                serializedName: "Translation",
                type: {
                    name: "String"
                }
            },
            taxonomyId: {
                required: true,
                serializedName: "TaxonomyId",
                type: {
                    name: "Number"
                }
            }
        }
    }
};
export var GlobalTagsTagGroupDto = {
    serializedName: "GlobalTagsTagGroupDto",
    type: {
        name: "Composite",
        className: "GlobalTagsTagGroupDto",
        modelProperties: {
            id: {
                serializedName: "Id",
                type: {
                    name: "String"
                }
            },
            name: {
                serializedName: "Name",
                type: {
                    name: "String"
                }
            },
            tags: {
                required: true,
                serializedName: "Tags",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalTagsTagDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalTagsTagGroupsDto = {
    serializedName: "GlobalTagsTagGroupsDto",
    type: {
        name: "Composite",
        className: "GlobalTagsTagGroupsDto",
        modelProperties: {
            tagGroupsCollection: {
                required: true,
                serializedName: "TagGroupsCollection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalTagsTagGroupDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalCustomersTermHtmlDto = {
    serializedName: "GlobalCustomersTermHtmlDto",
    type: {
        name: "Composite",
        className: "GlobalCustomersTermHtmlDto",
        modelProperties: {
            termId: {
                serializedName: "TermId",
                type: {
                    name: "String"
                }
            },
            version: {
                serializedName: "Version",
                type: {
                    name: "String"
                }
            },
            title: {
                serializedName: "Title",
                type: {
                    name: "String"
                }
            },
            header: {
                serializedName: "Header",
                type: {
                    name: "String"
                }
            },
            body: {
                serializedName: "Body",
                type: {
                    name: "String"
                }
            },
            footer: {
                serializedName: "Footer",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalConsultantsSettingDto = {
    serializedName: "GlobalConsultantsSettingDto",
    type: {
        name: "Composite",
        className: "GlobalConsultantsSettingDto",
        modelProperties: {
            setting: {
                serializedName: "Setting",
                type: {
                    name: "String"
                }
            },
            timestamp: {
                readOnly: true,
                serializedName: "Timestamp",
                type: {
                    name: "DateTime"
                }
            },
            format: {
                required: true,
                serializedName: "Format",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingVoucherCodeDto = {
    serializedName: "GlobalShoppingVoucherCodeDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingVoucherCodeDto",
        modelProperties: {
            voucherCode: {
                serializedName: "VoucherCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingVoucherCodesDto = {
    serializedName: "GlobalShoppingVoucherCodesDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingVoucherCodesDto",
        modelProperties: {
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingVoucherCodeDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalShoppingVoucherDto = {
    serializedName: "GlobalShoppingVoucherDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingVoucherDto",
        modelProperties: {
            isValid: {
                required: true,
                serializedName: "IsValid",
                type: {
                    name: "Boolean"
                }
            },
            description: {
                serializedName: "Description",
                type: {
                    name: "String"
                }
            },
            discount: {
                required: true,
                serializedName: "Discount",
                type: {
                    name: "Number"
                }
            },
            voucherCode: {
                serializedName: "VoucherCode",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalShoppingVouchersDto = {
    serializedName: "GlobalShoppingVouchersDto",
    type: {
        name: "Composite",
        className: "GlobalShoppingVouchersDto",
        modelProperties: {
            isAnyPromotionAvailable: {
                required: true,
                serializedName: "IsAnyPromotionAvailable",
                type: {
                    name: "Boolean"
                }
            },
            collection: {
                required: true,
                serializedName: "Collection",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingVoucherDto"
                        }
                    }
                }
            }
        }
    }
};
export var GlobalLoginWeChatAccountDto = {
    serializedName: "GlobalLoginWeChatAccountDto",
    type: {
        name: "Composite",
        className: "GlobalLoginWeChatAccountDto",
        modelProperties: {
            username: {
                serializedName: "Username",
                type: {
                    name: "String"
                }
            },
            password: {
                serializedName: "Password",
                type: {
                    name: "String"
                }
            },
            unionId: {
                serializedName: "UnionId",
                type: {
                    name: "String"
                }
            },
            profileImageUrl: {
                serializedName: "ProfileImageUrl",
                type: {
                    name: "String"
                }
            },
            fullName: {
                serializedName: "FullName",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalLoginProvidersWeChatPlatformDto = {
    serializedName: "GlobalLoginProvidersWeChatPlatformDto",
    type: {
        name: "Composite",
        className: "GlobalLoginProvidersWeChatPlatformDto",
        modelProperties: {
            openId: {
                serializedName: "OpenId",
                type: {
                    name: "String"
                }
            },
            type: {
                required: true,
                serializedName: "Type",
                type: {
                    name: "String"
                }
            }
        }
    }
};
export var GlobalLoginProvidersWeChatPlatformsDto = {
    serializedName: "GlobalLoginProvidersWeChatPlatformsDto",
    type: {
        name: "Composite",
        className: "GlobalLoginProvidersWeChatPlatformsDto",
        modelProperties: {
            items: {
                required: true,
                serializedName: "Items",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalLoginProvidersWeChatPlatformDto"
                        }
                    }
                }
            }
        }
    }
};

//# sourceMappingURL=mappers.js.map
